var tabs_header_top,
		product_column_right,
		develic_map;


function sticky() {

	$("#product_column_right_inner").stick_in_parent({ offset_top : 110, recalc_every: 100 })
  .on("sticky_kit:bottom", function(e) {
    $("#product_column_right_inner").addClass('bottomed');
  })
  .on("sticky_kit:unbottom", function(e) {
    $("#product_column_right_inner").removeClass('bottomed');
  });
}
$(window).on('load', function(){
	if ($('#product_columns').length) {
		$("#sticky_item").trigger("sticky_kit:detach");
		sticky();
		
		setInterval(function() {
			if ($('#product_column_right_inner').css('position') == 'fixed') {
				$('#product_column_right_inner').removeClass('bottomed');
			}
		},50);
	}
	updateStyles();
	posScrollDown();
	
	
	if ($('#upcoming').length && location.hash == '#upcoming') {
		$('html, body').animate({ scrollTop: $('#upcoming').offset().top - 250 }, 800, function(){ });		
	}
	if ($('#submit-an-event').length) {
		$('#c-7-261').attr('autocomplete','eventdate');
		$('#c-19-6').attr('autocomplete','address2');
	}
	if ($('#set-up-a-wholesale-account').length) {
		$('#c-1-262').attr('autocomplete','last_name');
		$('#c-4-260').attr('autocomplete','position');
		$('#c-8-256').attr('autocomplete','company');
		$('div[data-field="Email"] input').attr('autocomplete','email');
		$('.c-choice-checkboxes[data-field="Terms"] label > span').html('I agree to the Terms and Conditions at the top<span class="is-hidden-mobile"> right</span> of this page.');
	}
	
	// since cognito intercepts clicks on anchors, check every second to see if there are no c-remove-item and Repeat is hidden
	if ($('#submit-an-event').length) {
		setInterval(function() {
			if ($('.c-choice-checkboxes[data-field=Repeat]').hasClass('hide-it') && $('.c-remove-item').length < 1 && !$('.c-section[data-field=Until]').hasClass('show-it') && $('.c-section[data-field=EventDateTime2]').hasClass('show-it')) {
				$('.c-choice-checkboxes[data-field=Repeat]').removeClass('hide-it');
				$('.c-section[data-field=EventDateTime2]').removeClass('show-it');
				$('#c-10-258').prop('checked',false);
			}
		},1000);
		$('.c-date-date[data-field=Until]').append('<a href="#" class="remove-until"></a>');
	}

	// since cognito intercepts clicks on anchors, check every second to see if there are no c-remove-item and Repeat is hidden
	if ($('#copy-of-submit-an-event').length) {
		setInterval(function() {
			if ($('fieldset.cog-field--7-16').hasClass('hide-it') && $('section.cog-repeating-section__section .cog-repeating-section__heading button').length < 1 && !$('section.cog-field--7-15').hasClass('show-it') && $('section.cog-field--7-6').hasClass('show-it')) {
				$('fieldset.cog-field--7-16').removeClass('hide-it');
				$('section.cog-field--7-6').removeClass('show-it');
				$('input[type=checkbox][value="Multi-Day Event"]').prop('checked',false);
              	$('fieldset.cog-field--7-16 .el-checkbox__input,fieldset.cog-field--7-16 .el-checkbox').removeClass('is-checked');
			}
		},1000);
		$('section.cog-field--7-15').append('<a href="#" class="remove-until"></a>');
	}

});

$(document).ready(function() {
  

	var clipboard = new ClipboardJS('.share-link');
	$('.share-link').click(function(e) {
		e.preventDefault();
		$(this).addClass('tooltipped');
		setTimeout(function() {
			$('.share-link.tooltipped').removeClass('tooltipped');
		},1000);
	});


	//sign in page, change title and display different form for #recover
	if (location.hash == '#recover' && $('#account.template-customers-login').length) {
		$('h1').text('Forgot Your Password?');
		$('#customer_login').addClass('is-hidden');
		$('#recover_customer_password').removeClass('is-hidden');
	}
	$('#RecoverPassword').click(function(e) {
		e.preventDefault();
		$('h1').text('Forgot Your Password?');
		$('#customer_login').addClass('is-hidden');
		$('#recover_customer_password').removeClass('is-hidden');
	});
	//when customer_login email field is changed, update customer_login_header
	

	$('#local-shops-events').on('click','.develic-body p:first-child', function() {
		var parent = $(this).closest('.develic-item');
		$('a.develic-heading',parent)[0].dispatchEvent(new Event("click"));
	});
	$('#customer_login').on('change','input[name="customer[email]"]',function() {
		$('#customer_login_header input[name="customer[email]"]').val($(this).val());
	});
	//cognito submit an event form:
	$('#submit-an-event').on('change','.cognito #c-10-258', function() {
		if ($(this).is(':checked')) {
			$('.c-section[data-field=EventDateTime2]').addClass('show-it');
			$('.c-choice-checkboxes[data-field=Repeat]').addClass('hide-it');
			if ($('.c-remove-item').length < 1) {
				$('.c-add-item').trigger('click');
			}

			//c-8-260
			//c-9-259
		} else {
			$('.c-section[data-field=EventDateTime2]').removeClass('show-it');
			$('.c-choice-checkboxes[data-field=Repeat]').removeClass('hide-it');
		}
	});
	$('#submit-an-event').on('change','.cognito #c-10-257', function() {
		if ($(this).is(':checked')) {
			$('.c-section[data-field=Until]').addClass('show-it');
			$('.c-choice-checkboxes[data-field=Repeat]').addClass('hide-it');
			//c-8-260
			//c-9-259
		} else {
			$('.c-section[data-field=Until]').removeClass('show-it');
			$('.c-choice-checkboxes[data-field=Repeat]').removeClass('hide-it');
		}
	});
	$('#copy-of-submit-an-event,#submit-an-event').on('change','input[type=checkbox][value="Repeating Event"]', function() {
		if ($(this).is(':checked')) {
			$('section.cog-field--7-15').addClass('show-it');
			$('fieldset.cog-field--7-16').addClass('hide-it');
		} else {
			$('section.cog-field--7-6').removeClass('show-it');
			$('fieldset.cog-field--7-16').removeClass('hide-it');
		}
	});
  	$('#copy-of-submit-an-event,#submit-an-event').on('change','input[type=checkbox][value="Multi-Day Event"]', function() {
		if ($(this).is(':checked')) {
			$('section.cog-field--7-6').addClass('show-it');
			$('fieldset.cog-field--7-16').addClass('hide-it');
			if ($('section.cog-repeating-section__section .cog-repeating-section__heading button').length < 1) {
				$('.cog-repeating-section__add-button ').trigger('click');
			}
		} else {
			$('fieldset.cog-field--7-16').removeClass('show-it');
			$('section.cog-field--7-6').removeClass('hide-it');
		}
    });
	$('#submit-an-event').on('click','.remove-until',function(e) {
		e.preventDefault();
		$('.c-section[data-field=Until]').removeClass('show-it');
		$('.c-choice-checkboxes[data-field=Repeat]').removeClass('hide-it');
		$('.cognito #c-10-257').prop( 'checked', false );
	});
	$('#copy-of-submit-an-event').on('click','.remove-until',function(e) {
		e.preventDefault();
		$('section.cog-field--7-15').removeClass('show-it');
		$('fieldset.cog-field--7-16').removeClass('hide-it');
        $('input[type=checkbox][value="Repeating Event"]').prop('checked',false);
        $('fieldset.cog-field--7-16 .el-checkbox__input,fieldset.cog-field--7-16 .el-checkbox').removeClass('is-checked');
	});
	$('.navbar-burger').click(function(e) {
		e.preventDefault();
		$(this).toggleClass('is-active');
		$('#navMenu').toggleClass('is-active');
	});

	if ($('#product_columns').length) {
	
		var product_form = new Waypoint.Inview({
			element: $('#product_columns')[0],
			entered: function(direction) {
				if (direction == 'down') {
					$('#product_form').removeClass('fixed'); //'.css('left','1.2rem').css('width','auto');
				}
			},
			exit: function(direction) {
				if (direction == 'up') {
					$('#product_form').addClass('fixed'); //.css('left',$('#product_form_locator').offset().left).css('width',$('#product_form_locator').width());
					updateStyles();
				}
			}
		});


		waypoint_column();
	}
	
	$('.carousel').slick({
		centerMode: true,
		centerPadding: '28px',
		dots: true,
    prevArrow: false,
    nextArrow: false
	});

	$('.accordion-header.toggle').click(function() {
		var parent = $(this).closest('.accordion');
		parent.toggleClass('is-active');
		if ($('#product_column_right_inner').length) {
			setTimeout(function() {
				Waypoint.refreshAll();
				$(document.body).trigger("sticky_kit:recalc");
			},350);
		}
	});
	
	//product add to cart
	$('body').on('click','.dropdown-trigger button.button',function(e) {
		e.preventDefault();
		var parent = $(this).closest('.dropdown')
		
		parent.toggleClass('is-active');
		
		$('.dropdown.is-active').not(parent).removeClass('is-active');
	});
	$('.update-hidden').click(function(e) {
		e.preventDefault();
		setQueryStringParameter('variant',$(this).data('value'));

		var parent = $(this).closest('.dropdown.is-up')
		
		$('#ProductSelect-product-template').val($(this).data('value'));
		$('#ProductSelect-product-template-top').val($(this).data('value'));
		$('#product_top_form button span.inner').text($(this).text());
		$('#product_form button span.inner').text($(this).text());

		if ($('.gift-certificate').length) {
			if ($('#recipient-email').val() != '') {
				$('button[type=submit]').removeClass('is-light').addClass('is-dark');
			}
		} else {
			$('button[type=submit]').removeClass('is-light').addClass('is-dark');
		}

		parent.removeClass('is-active');
		setTimeout(function() {
			$('#ProductSelect-product-template-select').val($(this).data('value')).change();
		},1000);
	});
	$('#recipient-email').keyup(function() {
		if ($('#ProductSelect-product-template').val() != '') {
			$('button[type=submit]').removeClass('is-light').addClass('is-dark');
		}
	});
	$('.template-product .product-form form button[type=submit]').click(function(e) {
		if (!$('#cocoknits-method-video-class-video-series').length) {
			if (!$(this).hasClass('is-dark')) {
				e.preventDefault();
			} else {
				var form = $(this).closest('form');
				form.submit();
			}
		}
	});
	$('.modal-close, .modal-background').on('click',function() {
      $('.modal').removeClass('is-active');
	});

	//$('#customer-login').load('/pages/login');

	$('#HeaderLoginForm #customer_login').attr('id','customer_login_header');
	
	var cart_count = 0;
	
	$.getJSON('/cart.js', function(cart) {
		cart_count = cart['item_count'];
        var cart_data = { updates: {} },
            runCartUpdate = false;

        $.each(cart['items'], function(key,value) {
			if ($('body.wholesale-menu').length > 0) {
				//if there are items on this page, update the quantity and totals to reflect what is in the cart
				$('.wholesale-item').each(function(i) {
					if (value.id == $('.product_id',this).val()) {
						$('.quantity',this).val(value.quantity);
						$('.total',this).text('$'+(value.quantity*$('.quantity',this).data('price')/100).toFixed(2));
					}
				});
				//remove non-wholesale items
				if (value.product_type.indexOf('Wholesale') < 0 && value.product_type != 'Wholesale Video Class') {
					//$.post('/cart/change.js', { quantity: 0, id: value.id }, function(){}, 'json');
                  	cart_data.updates[value.id] = 0;
                    runCartUpdate = true;
					cart_count = cart_count - value.quantity;
				}
			} else {
				//remove wholesale items
				if (value.product_type.indexOf('Wholesale') > -1 || value.product_type == 'Wholesale Video Class') {
					//$.post('/cart/change.js', { quantity: 0, id: value.id }, function(){}, 'json');
                    cart_data.updates[value.id] = 0;
                    runCartUpdate = true;
					cart_count = cart_count - value.quantity;
				}
			}
		});
      
      if (runCartUpdate) {
        $.post('/cart/update.js', cart_data, function(){ location.reload(true); }, 'json');
      }
		if (cart_count > 0) {
			$('.navbar-item.cart-item').removeClass('is-hidden').text(cart_count+' item'+(cart_count>1?'s':''));
			$('.navbar-item.customer-account.is-hidden-tablet').addClass('is-hidden');
		}
		collectionsSubtotals();
		
	});
	
	/* navbar search */
	$('.navbar-item.search-item span.icon').click(function(e) {
		e.preventDefault();
		var parent = $(this).closest('.navbar-item.search-item');
		
		if ($('.navbar-item.search-header').hasClass('is-open') || $(window).width() < 768) {
			if ($('input.search-input',parent).val() == '') {
				$('.navbar-item.search-header').removeClass('is-open');
			} else {
				$('form',parent).submit();
				$('.navbar-item.search-header').removeClass('is-open');
			}
		} else {
			$('.navbar-item.search-header').addClass('is-open');
		}
	});
//	$('#navMenu').on('focus','.search-input', function() {
//		if ($(window).width() < 769) {
//			setTimeout(function() {
//				$('.navbar.is-fixed-top .navbar-menu').animate({ scrollTop: $('.navbar.is-fixed-top .navbar-menu').offset().top + 600 }, 800, function(){ });
//			},1000);
//		}
//	});
		
	$('.wholesale-item').on('change','.quantity',function() {
		var parent = $(this).closest('.wholesale-item');
		
		if ($(this).val() == 0) {
			$('.total',parent).text('');
		} else {
			$('.total',parent).text('$'+($(this).val()*$(this).data('price')/100).toFixed(2));
		}
	});
	$('.wholesale-item').on('change','.quantity-selector',function(e) {
		e.preventDefault();
		var parent = $(this).closest('.wholesale-item');
		
		if ($('.add-to-bag .add-to-cart',parent).hasClass('video-class') && $('.quantity',parent).val() != 0) {
			$('#video-modal').addClass('is-active');
		} else {
			wholesaleAddToCart($('.add-to-bag .add-to-cart',parent));
		}
	});
	$('body').on('click','.button-wrapper a.dropdown-item',function(e) {
		e.preventDefault();
		
		var parent = $(this).closest('.button-wrapper');
		$('.ajax-addtocart',parent).data('id',$(this).data('value')).removeClass('is-light');
		$('.dropdown',parent).removeClass('is-active');
		$('.dropdown-trigger button .inner',parent).text($(this).text());
	});
	$('body').on('click','.button-wrapper a.button',function(e) {
		e.preventDefault();
		var abutton = $(this);
		
		if (abutton.data('id')) {
			abutton.fadeOut('fast',function() { abutton.text('ADDED').fadeIn('fast') });
			setTimeout(function() {
				abutton.fadeOut('fast',function() { abutton.text('ADD TO BAG').fadeIn('fast') });
			},3000);
			$.getJSON('/cart.js', function(cart) {
				cart_count = cart['item_count'];
				var existing = false;
				$.each(cart['items'], function(key,value) {
					if (value.variant_id == abutton.data('id')) {
						existing = true;
						$.post('/cart/change.js', { quantity: (value.quantity + 1), id: abutton.data('id') },function() {
							$.getJSON('/cart.js', function(cart) {
								var cart_count = cart['item_count'];
								if (cart_count > 0) {
									$('.navbar-item.cart-item').removeClass('is-hidden').text(cart_count+' item'+(cart_count>1?'s':''));
									$('.navbar-item.customer-account.is-hidden-tablet').addClass('is-hidden');				
								} else {
									$('.navbar-item.cart-item').addClass('is-hidden').text(cart_count+' item'+(cart_count>1?'s':''));
									$('.navbar-item.customer-account.is-hidden-tablet').removeClass('is-hidden');				
								}
	
							});
						}, 'json');
					}
				});
				if (!existing) {
					var formdata = { quantity: 1, id:  abutton.data('id') };
					
					$.post('/cart/add.js', formdata, function(data) {
						$.getJSON('/cart.js', function(cart) {
							var cart_count = cart['item_count'];
							if (cart_count > 0) {
								$('.navbar-item.cart-item').removeClass('is-hidden').text(cart_count+' item'+(cart_count>1?'s':''));
								$('.navbar-item.customer-account.is-hidden-tablet').addClass('is-hidden');				
							} else {
								$('.navbar-item.cart-item').addClass('is-hidden').text(cart_count+' item'+(cart_count>1?'s':''));
								$('.navbar-item.customer-account.is-hidden-tablet').removeClass('is-hidden');				
							}
						});
					}, 'json');
				}
			});
			
		}
	});
	if ($('.load-article').length > 0) {
		$('.load-article').each(function() {
			$(this).on('load', $(this).data('target'));
		});
	}
	
	//position img at bottom of nav
	$('.follows-heading img').on('load', function() {
		assignTops();
		$(this).addClass('loaded');
	});
	if ($('.follows-heading img:first-child').length) {
		if ($('.follows-heading img:first-child')[0].complete) {
			assignTops();
			$('.follows-heading img:first-child').addClass('loaded');
		}	
	} else {
		assignTops();
	}
	//login hover override for autocomplete
	$('#customer-login').on('focus', 'input', function () {
		if ($('#customer-login').css('opacity') > 0) {
			$('#customer-login').addClass("is-open");
		}
	}).on('blur', 'input', function () {
		if ($('#customer-login input[type=email]').val() == '') {
			$("#customer-login").removeClass("is-open");
			$('#customer-login input').blur();
		}
	});
	$('body > *').not('#shopify-section-header').click(function() {
		$("#customer-login").removeClass("is-open");
		$('.navbar-item.search-header').removeClass('is-open');
//		$('#customer-login input').blur();
	});
	$('.navbar-item').mouseover(function() {
//		$("#customer-login").removeClass("is-open");
//		$('#customer-login input').blur();
	});
	
	updateStyles();
	$('.bd-tabs a').click(function() {
		$('.bd-tabs li.is-active').removeClass('is-active');
		$(this).closest('li').addClass('is-active');
	});
	$('.smooth .dropdown-item').click(function() {
		$('.smooth .dropdown-item.is-active').removeClass('is-active');
		$(this).addClass('is-active');
		$('.smooth .dropdown').removeClass('is-active');
	});
	$('.smooth a, a#scrollDown').on('click', function(event) {
    // Make sure this.hash has a value before overriding default behavior
    if (this.hash !== "") {
      // Prevent default anchor click behavior
      event.preventDefault();

      // Store hash
      var hash = this.hash;

      // Using jQuery's animate() method to add smooth page scroll
      // The optional number (800) specifies the number of milliseconds it takes to scroll to the specified area
			if ($('.hero.top .container a').length) {
	      $('html, body').animate({ scrollTop: $(hash).offset().top }, 800, function(){/* window.location.hash = hash; */ });
	    } else {
	      $('html, body').animate({ scrollTop: $(hash).offset().top - 100 }, 800, function(){/* window.location.hash = hash; */ });
	    }
    } // End if
  });
  //$('.customer-account').click(function(e) {
  	//if ($(window).width() > 768) {
  		//e.preventDefault();
  	//}
  //});
  if ($('.sticky-leftnav')) {
		$(".sticky-leftnav").stick_in_parent({ offset_top : 110, recalc_every: 100 });
  }
  
  //sort articles
  if ($('#articlelist').length) {
  	if ($('.template-page-pastevents').length) {
	  	$('#articlelist').sortReverseDivs();
  	} else {
	  	$('#articlelist').sortDivs();
  	}
  	
  	paginateArticles();
	}
	$('form.article-filter').on('submit',function(e) {
		e.preventDefault();
		filterArticles();
	});
	$('form.article-filter span.icon').on('click',function(e) {
		e.preventDefault();
		filterArticles();
	});
	$('a.disabled').on('click',function(e) {
		e.preventDefault();
	});
	$('.pagination-links').on('click','a.next:not(.is-hidden)', function(e) {
		e.preventDefault();
		var count = 0,
				notthisone = true;
		$('.pagination-links a.previous').removeClass('is-hidden')
		$('.pagination-links a.next').addClass('is-hidden')
		$('#articlelist .columns.filtered').each(function(index, value) {
			notthisone = false;
			if ($(this).is(':visible')) {
				$(this).hide();
				count++;
				notthisone = true;
			}
			if (!notthisone && !$(this).is(':visible') && count > 0) {
				count--;
				$(this).fadeIn('fast');
				if (count == 0 && $('#articlelist .columns.filtered').length > index) {
					$('.pagination-links a.next').removeClass('is-hidden')
				}
			}			
		});
		$('html, body').animate({ scrollTop: $('#articlelist').offset().top - 200 }, 800, function(){ });
	});
	$('.pagination-links').on('click','a.previous:not(.is-hidden)', function(e) {
		e.preventDefault();
		var count = 0,
				notthisone = false,
				countdown = 5;
		$('.pagination-links a.previous').addClass('is-hidden')
		$('.pagination-links a.next').removeClass('is-hidden')
		$($('#articlelist .columns.filtered').get().reverse()).each(function(index, value) {
			notthisone = false;
			if ($(this).is(':visible')) {
				$(this).hide();
				count++;
				notthisone = true;
			}
			if (!notthisone && !$(this).is(':visible') && countdown > 0 && count > 0) {
				countdown--;
				$(this).fadeIn('fast');
				if (countdown == 0 && $('#articlelist .columns.filtered').length > index && !$('#articlelist .columns.filtered:eq(0)').is(":visible")) {
					$('.pagination-links a.previous').removeClass('is-hidden')
				}
			}			
		});
		$('html, body').animate({ scrollTop: $('#articlelist').offset().top - 200 }, 800, function(){ });
	});
	
	//check bookmark status every second to see if it should change
	if ($('.template-product').length) {
		setInterval(function() {
			if ($('.esc-wishlist__add-to-wishlist__button:visible').text() == 'Added to a Wishlist') {
				$('.esc-wishlist__add-to-wishlist__button:not(.bookmarked)').addClass('bookmarked');
			} else {
				$('.esc-wishlist__add-to-wishlist__button').removeClass('bookmarked');
			}
		},1000);
	}
	
	//automatically update cart on qantity change on cart page
	$('#your-shopping-cart form.cart input.quantity-selector').change(function(){
		var formdata = { quantity: $(this).val(), id: $(this).data('id') },
				parent = $(this).closest('.border-top'),
				line = $(this).data('line');
				
		$.post('/cart/change.js', formdata, function(data) {
			if (formdata['quantity'] == 0) {
				location.reload(true);
			}
			$('.cart__subtotal-price b').text(formatMoney(data.total_price));
			$('.item-subtotal',parent).text(formatMoney(data.items[line].line_price));
			if (data['item_count'] > 0) {
				$('.navbar-item.cart-item').removeClass('is-hidden').text(data['item_count']+' item'+(data['item_count']>1?'s':''));
				$('.navbar-item.customer-account.is-hidden-tablet').addClass('is-hidden');				
			}
			
		}, 'json');
		
	});
	
	//show past orders in account
	if ($('.template-customers-account').length && getUrlParameter('section')) {
		if (getUrlParameter('section') == 'order_history') {
			$('.pastorders-table').removeClass('is-hidden');
			$('.default, .default-top, .account-title').addClass('is-hidden');
			if ($('.wholesale-menu').length) {
				$('.order-title-wholesale').removeClass('is-hidden');
			} else {
				$('.order-title').removeClass('is-hidden');
			}
		}
	}
	
	//force callout urls to target _blank
	$('#things-we-love .callout a, .team-member a').each(function() {
		$(this).attr('target','_blank');
	});
	//address delete 
	$('.address-delete').click(function(e) {
		e.preventDefault();
		var parent = $(this).closest('.links');
		if (window.confirm($(this).data('confirm-message') || 'Are you sure you wish to delete this address?')) {
			$('.address-delete-form',parent).submit();
		}
	});
	
	$('.address-new-toggle').click(function(e) {
		e.preventDefault();
		if ($('#current-addresses:visible').length) {
			$('#current-addresses').fadeOut(300);
			setTimeout(function() {
				$('#AddressNewForm').hide().removeClass('is-hidden').fadeIn(300);
			},350);
		} else {
			$('#AddressNewForm').fadeOut(300);
			setTimeout(function() {
				$('#current-addresses').fadeIn(300);
			},350);
		}
	});

	$('.address-edit-toggle').on('click', function(e) {
		e.preventDefault();
		var formId = $(this).data('form-id');

		if ($('#current-addresses:visible').length) {
			$('#current-addresses').fadeOut(300);
			setTimeout(function() {
				$('#EditAddress_' + formId).hide().removeClass('is-hidden').fadeIn(300);
			},350);
		} else {
			$('#EditAddress_' + formId).fadeOut(300);
			setTimeout(function() {
				$('#current-addresses').fadeIn(300);
			},350);
		}
		
	});
	

	/* set variant if sent as parameter */
	if ($('.template-product').length && getUrlParameter('variant')) {
		var variant = getUrlParameter('variant');
		
		$('form .dropdown.is-up').each(function() {
			var parent = $(this);
			$('.dropdown-item').each(function() {
				if ($(this).data('value') == variant) {
					$('#ProductSelect-product-template-top').val(variant);
					$('#ProductSelect-product-template').val(variant);
					$('.dropdown-trigger button .inner',parent).text($(this).text());
					if (!$(this).hasClass('reload')) {
						$('button[type=submit]').removeClass('is-light').addClass('is-dark');
					}
				}
			});
		});
	}
	if ($('.reset-password-success').length) {
		$('#ResetSuccess').removeClass('is-hidden');
	}
	
	$('.dropdown-item.reload').click(function() {
		setTimeout(function() {
			location.reload();
		},500);
	})

	styleWishlist();
	
	//multiple paginations per page, wholesale news
	$('.paginated').on('click','.pagination-call a',function(e) {
		e.preventDefault();
		var parent = $(this).closest('.paginated'),
				target = $('.pagination-get',parent).data('target') + $(this).attr('href').substring($(this).attr('href').indexOf('?'));
		

		$.ajax({
			type: "GET",
			url: target,
			success: function( response ) {
				var responseElem = $(response);
				$('.pagination-get',parent).html($('#pagination-block',responseElem).html());
			}
		});
		//$('.pagination-get',parent).load(target);
	});
	
	//control redirect on logout
  $('body').on('click', 'a[href^="/account/logout"]', function() {
  	removeEverything();
  	if (window.location.pathname.indexOf('cocoknits-method-video-class') == -1) {
			$.ajax( $(this).attr('href') )
				.done(function() {
					if (typeof(logouttarget) != 'undefined') {
						window.location.href = logouttarget;
					} else {
						location.reload();
					}
					// Here you will change the url to whatever page you want to redirect to
					//window.location.href = "/pages/my-shopify-page";
				});
			return false;
  	}
  });
  
  if (navigator.cookieEnabled) {
  	$('.cart--cookie-message').addClass('is-hidden');
  }
	//Video Class AddToCart and AddToCartTop require modal terms
	$('#cocoknits-method-video-class-video-series #AddToCart, #cocoknits-method-video-class-video-series #AddToCartTop').click(function(e) {
		e.preventDefault();
		$('#video-modal').addClass('is-active');
	});
	$('#video-modal a.button').click(function(e) {
		e.preventDefault();
		if ($('.template-product').length) {
			$('#product_form form').submit();
		} else {
			wholesaleAddToCart($('.add-to-bag .video-class.add-to-cart'));
			$('#video-modal').removeClass('is-active');
		}
	});
	sizeVimeo();
	
	$('.map-wrapper').on('input', '.develic-search-input', develic_search_change);
	$('.map-wrapper').on('click', '.develic-search-autocomplete-option', develic_search_change);

  $('.material-thumbs').on('click', '.material-thumb', function(e) {
    $('.modal',$(this).parent('.column')).addClass('is-active');
    if ($(window).width() > 768) {
      var fillHeight = $('#sustainable-materials .modal.is-active .is-one-third').outerHeight() - $('#sustainable-materials .modal.is-active .is-two-thirds .columns.is-variable').first().outerHeight();
      $('#sustainable-materials .modal.is-active .is-two-thirds .columns.is-variable.is-fullheight').height(fillHeight);
    } else {
      $('#sustainable-materials .modal.is-active .is-two-thirds .columns.is-variable.is-fullheight').height('auto');
    }    
  });
});

function develic_set_map(map) {
	develic_map = map;
}
function develic_search_change() {
	setTimeout(function() {
		var search_term = $('.develic-search-input').val().toLowerCase();

		if (!search_term.match(/^\d/)) {
			var geocoder = new google.maps.Geocoder();
			 geocoder.geocode( { 'address': search_term}, function(results, status) {
				if (status == google.maps.GeocoderStatus.OK) {
					develic_map.fitBounds(results[0].geometry.viewport);
				}
			});
		}
	},1000);		
}
function wholesaleAddToCart(ele) {
	var parent = ele.closest('.wholesale-item'),
			formdata = { quantity: $('.quantity',parent).val(), id: $('.product_id',parent).val() },
			cart,
			existing = false,
			cart_count = 0;
	
	if (ele.hasClass('video-class')) {
		if ($('.quantity',parent).val() > 1) {
			$('.quantity',parent).val(1);
		}
	}
	//get a fresh cart
	$.getJSON('/cart.js', function(cart) {
		cart_count = cart['item_count'];
		$.each(cart['items'], function(key,value) {
			//remove non-wholesale items
			if (value.product_type.indexOf('Wholesale') == -1 && value.product_type != 'Wholesale Video Class') {
				$.post('/cart/change.js', { quantity: 0, id: value.id });
				cart_count = cart_count - value.quantity;
			} else {
				//check to see if this item is already in the cart
				if (value.variant_id == $('.product_id',parent).val()) {
					existing = true;
					$.post('/cart/change.js', { quantity: $('.quantity',parent).val(), id: $('.product_id',parent).val() },function() {
						$.getJSON('/cart.js', function(cart) {
							var cart_count = cart['item_count'];
							if (cart_count > 0) {
								$('.navbar-item.cart-item').removeClass('is-hidden').text(cart_count+' item'+(cart_count>1?'s':''));
								$('.navbar-item.customer-account.is-hidden-tablet').addClass('is-hidden');				
							} else {
								$('.navbar-item.cart-item').addClass('is-hidden').text(cart_count+' item'+(cart_count>1?'s':''));
								$('.navbar-item.customer-account.is-hidden-tablet').removeClass('is-hidden');				
							}
		
						});
					}, 'json');
				}
			}
		});
		if (!existing) {
			$.post('/cart/add.js', formdata, function(data) {
				$.getJSON('/cart.js', function(cart) {
					var cart_count = cart['item_count'];
					if (cart_count > 0) {
						$('.navbar-item.cart-item').removeClass('is-hidden').text(cart_count+' item'+(cart_count>1?'s':''));
						$('.navbar-item.customer-account.is-hidden-tablet').addClass('is-hidden');				
					} else {
						$('.navbar-item.cart-item').addClass('is-hidden').text(cart_count+' item'+(cart_count>1?'s':''));
						$('.navbar-item.customer-account.is-hidden-tablet').removeClass('is-hidden');				
					}
				});
			}, 'json');
		}
	});
	collectionsSubtotals();
}
function sizeVimeo() {
	$('.embed-vimeo iframe').each(function() {
		var parent = $(this).closest('.embed-vimeo');
		if ($(this).data('width') && $(this).data('height')) {
			$(this).height(parent.width()*parseInt($(this).data('height'))/parseInt($(this).data('width')));
		}
	});
}
function collectionsSubtotals() {
	$('.collection-items').each(function() {
		var parent = this,
				sectionSubtotal = 0;
		$('.total',parent).each(function() {
			if ($(this).text() + '') {
				sectionSubtotal = sectionSubtotal + parseFloat($(this).text().replace('$',''));
			}
		});
		$('.section-subtotal',parent).text('$'+sectionSubtotal.toFixed(2));
	});
	var sectionsTotal = 0;
	$('.section-subtotal').each(function() {
		if ($(this).text() + '') {
			sectionsTotal = sectionsTotal + parseFloat($(this).text().replace('$',''));
		}
	});
	$('.sections-total').text('$'+sectionsTotal.toFixed(2));
	
}
function styleWishlist() {
	/* wishlist age overrides */
	if ($("#wishlists").length) {
		if ($('#wishlists #eastsideco_wishlist .esc-wishlist-item').length || $('#wishlists #eastsideco_wishlist .esc-wishlist-product-item').length) {
			$('#eastsideco_wishlist').hide();
		}
		var styleWL = setInterval(function() {
			if ($('.esc-wishlist-add button').text().toLowerCase() == 'add a wishlist') $('.esc-wishlist-add button').text('CREATE NEW LIST');
			if ($('#wishlists #eastsideco_wishlist .esc-wishlist-item').length && $('#wishlists #eastsideco_wishlist .esc-wishlist-item.columns').length < 1) {
				$('#wishlists #eastsideco_wishlist .esc-wishlist-item').each(function() {
					$(this).addClass('columns');
					$('.esc-wishlist-item-image',this).addClass('is-hidden');
					$('.esc-wishlist-item-name a',this).attr('href','/pages/wishlists/'+$('.esc-wishlist-item-name a',this).attr('href'));
					$('.esc-wishlist-item-name',this).addClass('column is-4 has-text-centered-mobile').append('&nbsp;&nbsp;<a href="'+$('.esc-wishlist-item-name a',this).attr('href')+'" class="styled">SHARE</a>');
					$('.esc-wishlist-item-actions',this).addClass('column is-8 has-text-centered-mobile');
				});
				if ($('.esc-wishlists .table-heading').length == 0) {
					$('.esc-wishlists').prepend('<div class="columns is-hidden-mobile sans table-heading"><div class="column is-4">List Name</div><div class="column is-8">Actions</div></div>');
				}
				if (!$('.esc-wishlist-add').hasClass('moved')) $('.esc-wishlist-add').addClass('moved').insertAfter('.esc-wishlists');
				//clearInterval(styleWL);
				$('#eastsideco_wishlist').fadeIn('fast');
			
			}
		
			/* for wishlist detail page */
			if ($('#wishlists #eastsideco_wishlist .esc-wishlist-products').length && $('#wishlists #eastsideco_wishlist .esc-wishlist-product-item.columns').length < 1) {
				$('#wishlists #eastsideco_wishlist .esc-wishlist-product-item').each(function() {
					$(this).addClass('columns');
					$('.esc-wishlist-product-item-image-container',this).addClass('column is-image-width');
					$('.esc-wishlist-product-item-title',this).addClass('column');
					$('.esc-wishlist-product-item-price',this).addClass('column sans is-2');
					$('.esc-wishlist-product-item-actions',this).addClass('column');
				});
				if ($('.esc-wishlist-products .table-heading').length == 0) {
					if ($('.esc-wishlist-product-item-actions').length) {
						$('.esc-wishlist-products').prepend('<div class="columns is-hidden-mobile sans table-heading"><div class="column is-image-width"></div><div class="column">Product</div><div class="column is-2">Price</div><div class="column">Actions</div></div>');
					} else {
						$('.esc-wishlist-products').prepend('<div class="columns is-hidden-mobile sans table-heading"><div class="column is-image-width"></div><div class="column">Product</div><div class="column">Price</div></div>');
					}
				}
				if ($('.esc-wishlist-product-item.columns').length) {
					//clearInterval(styleWL);
				}
				if (!$('.esc-wishlist-add').hasClass('moved')) $('.esc-wishlist-add').addClass('moved').insertAfter('.esc-wishlist-products');
				if ($('.esc-wishlist-add button').text().toLowerCase() == 'add a wishlist') $('.esc-wishlist-add button').text('CREATE NEW LIST');
				$('#eastsideco_wishlist').fadeIn('fast');
			}
		},1000);
		setInterval(function() {
			$('#wishlists #eastsideco_wishlist .esc-wishlist-item').each(function() {
				if (!$(this).hasClass('columns')) $(this).addClass('columns');
				if (!$('.esc-wishlist-item-name',this).hasClass('column')) $('.esc-wishlist-item-name',this).addClass('column is-4 has-text-centered-mobile').append('&nbsp;&nbsp;<a href="#'+$('.esc-wishlist-item-name a',this).attr('href')+'" class="styled">SHARE</a>');
				if (!$('.esc-wishlist-item-actions',this).hasClass('column')) $('.esc-wishlist-item-actions',this).addClass('column is-8 has-text-centered-mobile');
			});
		},1000);
		
		/* have to keep checking in case of update */
	}
}
function paginateArticles() {
	if ($('.columns.filtered').length > 5) {
		$('.pagination-links').show();
		$('.columns.filtered:gt(4)').hide();
		$('.pagination-links a.next').removeClass('is-hidden')
	} else {
		$('.pagination-links').hide();
	}
}
function filterArticles() {
	$('#articlelist > div.columns').each(function() {
		$(this).removeClass('filtered');
		if ($(this).text().toLowerCase().indexOf($('form.article-filter input').val().toLowerCase()) > -1) {
			if (!$(this).hasClass('no-results')) {
				$(this).addClass('filtered');
			}
		}
	});
	if ($('.filtered').length == 0) {
		$('.no-results').addClass('filtered');
	}
	paginateArticles();
}
jQuery.fn.sortDivs = function sortDivs() {
	$("> div", this[0]).sort(dec_sort).appendTo(this[0]);
	function dec_sort(a, b){ return ($(b).data("sort")) < ($(a).data("sort")) ? 1 : -1; }
}
jQuery.fn.sortReverseDivs = function sortReverseDivs() {
	$("> div", this[0]).sort(dec_sort).appendTo(this[0]);
	function dec_sort(a, b){ return ($(b).data("sort")) > ($(a).data("sort")) ? 1 : -1; }
}
function posScrollDown() {
	var difference = $('section.hero').height() - $(window).height() + 55;
	if (difference > 0) {
		if ($(window).scrollTop() < difference) {
			$('#scrollDown').stop().animate({'bottom':(difference-$(window).scrollTop())+15+'px'},0);
		} else {
			$('#scrollDown').css('bottom','15px');
		}
	}
}
function updateStyles() {
	// match widths
	$('.template-product form .dropdown.is-up').each(function() {
		$('button',this).width($('.dropdown-menu',this).width()-26);
	});

	$('#dynstyles').remove();
	var styleString  = '';
	styleString += '<style id="dynstyles">';
	styleString += '@media screen and (min-width: 769px) {';
	if ($('#product_form_locator').length) {
		styleString += '.bottomed { left: calc(10% + 18px) !important }';
		styleString += '.is_stuck { margin-left: 0 !important; left:'+$('#product_form_locator').offset().left+'px; }';
		styleString += '#product_form.fixed { left: '+$('#product_form_locator').offset().left+'px; width:'+(32 + $('#product_form_locator').width())+'px; }';
	}
	styleString += '}';


	styleString += '</style>';
	$('head').append(styleString);
	
	if ($(window).width() > 768) {
		$('.growcontents').each(function() {
			var hcoll = 0;
			$('> div',this).each(function() {
				$(this).height('auto');
				hcoll+= $(this).height();
			});
			if (hcoll < $(this).height()) {
				$('> div:last-child',this).height($('> div:last-child',this).height() + ($(this).height() - hcoll) + 16);
			}
		});
	} else {
		$('.growcontents > div').height('auto');
	}
}

function assignTops() {
	$('.follows-heading').each(function() {
		if ($(window).width() > 768) {
			$('img.image:first-child',this).css('margin-top','-'+(parseInt($('.contains-heading').height())+parseInt($(this).css('padding-top'))+parseInt($('.contains-heading').css('padding-bottom')))+'px');
		} else {
			$('img.image:first-child',this).css('margin-top','0px');
		}
	});
}
$(window).resize(function() {
	assignTops();
	updateStyles();
	sizeVimeo();
	posScrollDown();
});

$(window).scroll(function() {
	if ($('.dropdown.is-active').length && !$('.dropdown.is-active').is(':hover')) {
		$('.dropdown').removeClass('is-active');
	}
	if ($('.template-index').length) {
		posScrollDown();
	}
});


if ($('.is-fixed-on-scroll').length) {
	$(window).on('load', function() {
		$('.is-fixed-on-scroll').addClass('loaded').stick_in_parent({ offset_top : 50 });
	});
}

function waypoint_column() {
	if ($('#product_column_right_inner').length) {
	}
}
function setQueryStringParameter(name, value) {
	var newurl =
			window.location.protocol +
			'//' +
			window.location.host +
			window.location.pathname +
			'?'+name+'=' +
			value;
	window.history.replaceState({ path: newurl }, "",newurl);
}

var getUrlParameter = function getUrlParameter(sParam) {
	var sPageURL = decodeURIComponent(window.location.search.substring(1)),
			sURLVariables = sPageURL.split('&'),
			sParameterName,
			i;

	for (i = 0; i < sURLVariables.length; i++) {
		sParameterName = sURLVariables[i].split('=');
		if (sParameterName[0] === sParam) {
			return sParameterName[1] === undefined ? true : sParameterName[1];
		}
	}
	return false;
};


/* slick carousel */
!function(i){"use strict";"function"==typeof define&&define.amd?define(["jquery"],i):"undefined"!=typeof exports?module.exports=i(require("jquery")):i(jQuery)}(function(i){"use strict";var e=window.Slick||{};(e=function(){var e=0;return function(t,o){var s,n=this;n.defaults={accessibility:!0,adaptiveHeight:!1,appendArrows:i(t),appendDots:i(t),arrows:!0,asNavFor:null,prevArrow:'<button class="slick-prev" aria-label="Previous" type="button">Previous</button>',nextArrow:'<button class="slick-next" aria-label="Next" type="button">Next</button>',autoplay:!1,autoplaySpeed:3e3,centerMode:!1,centerPadding:"50px",cssEase:"ease",customPaging:function(e,t){return i('<button type="button" />').text(t+1)},dots:!1,dotsClass:"slick-dots",draggable:!0,easing:"linear",edgeFriction:.35,fade:!1,focusOnSelect:!1,focusOnChange:!1,infinite:!0,initialSlide:0,lazyLoad:"ondemand",mobileFirst:!1,pauseOnHover:!0,pauseOnFocus:!0,pauseOnDotsHover:!1,respondTo:"window",responsive:null,rows:1,rtl:!1,slide:"",slidesPerRow:1,slidesToShow:1,slidesToScroll:1,speed:500,swipe:!0,swipeToSlide:!1,touchMove:!0,touchThreshold:5,useCSS:!0,useTransform:!0,variableWidth:!1,vertical:!1,verticalSwiping:!1,waitForAnimate:!0,zIndex:1e3},n.initials={animating:!1,dragging:!1,autoPlayTimer:null,currentDirection:0,currentLeft:null,currentSlide:0,direction:1,$dots:null,listWidth:null,listHeight:null,loadIndex:0,$nextArrow:null,$prevArrow:null,scrolling:!1,slideCount:null,slideWidth:null,$slideTrack:null,$slides:null,sliding:!1,slideOffset:0,swipeLeft:null,swiping:!1,$list:null,touchObject:{},transformsEnabled:!1,unslicked:!1},i.extend(n,n.initials),n.activeBreakpoint=null,n.animType=null,n.animProp=null,n.breakpoints=[],n.breakpointSettings=[],n.cssTransitions=!1,n.focussed=!1,n.interrupted=!1,n.hidden="hidden",n.paused=!0,n.positionProp=null,n.respondTo=null,n.rowCount=1,n.shouldClick=!0,n.$slider=i(t),n.$slidesCache=null,n.transformType=null,n.transitionType=null,n.visibilityChange="visibilitychange",n.windowWidth=0,n.windowTimer=null,s=i(t).data("slick")||{},n.options=i.extend({},n.defaults,o,s),n.currentSlide=n.options.initialSlide,n.originalSettings=n.options,void 0!==document.mozHidden?(n.hidden="mozHidden",n.visibilityChange="mozvisibilitychange"):void 0!==document.webkitHidden&&(n.hidden="webkitHidden",n.visibilityChange="webkitvisibilitychange"),n.autoPlay=i.proxy(n.autoPlay,n),n.autoPlayClear=i.proxy(n.autoPlayClear,n),n.autoPlayIterator=i.proxy(n.autoPlayIterator,n),n.changeSlide=i.proxy(n.changeSlide,n),n.clickHandler=i.proxy(n.clickHandler,n),n.selectHandler=i.proxy(n.selectHandler,n),n.setPosition=i.proxy(n.setPosition,n),n.swipeHandler=i.proxy(n.swipeHandler,n),n.dragHandler=i.proxy(n.dragHandler,n),n.keyHandler=i.proxy(n.keyHandler,n),n.instanceUid=e++,n.htmlExpr=/^(?:\s*(<[\w\W]+>)[^>]*)$/,n.registerBreakpoints(),n.init(!0)}}()).prototype.activateADA=function(){this.$slideTrack.find(".slick-active").attr({"aria-hidden":"false"}).find("a, input, button, select").attr({tabindex:"0"})},e.prototype.addSlide=e.prototype.slickAdd=function(e,t,o){var s=this;if("boolean"==typeof t)o=t,t=null;else if(t<0||t>=s.slideCount)return!1;s.unload(),"number"==typeof t?0===t&&0===s.$slides.length?i(e).appendTo(s.$slideTrack):o?i(e).insertBefore(s.$slides.eq(t)):i(e).insertAfter(s.$slides.eq(t)):!0===o?i(e).prependTo(s.$slideTrack):i(e).appendTo(s.$slideTrack),s.$slides=s.$slideTrack.children(this.options.slide),s.$slideTrack.children(this.options.slide).detach(),s.$slideTrack.append(s.$slides),s.$slides.each(function(e,t){i(t).attr("data-slick-index",e)}),s.$slidesCache=s.$slides,s.reinit()},e.prototype.animateHeight=function(){var i=this;if(1===i.options.slidesToShow&&!0===i.options.adaptiveHeight&&!1===i.options.vertical){var e=i.$slides.eq(i.currentSlide).outerHeight(!0);i.$list.animate({height:e},i.options.speed)}},e.prototype.animateSlide=function(e,t){var o={},s=this;s.animateHeight(),!0===s.options.rtl&&!1===s.options.vertical&&(e=-e),!1===s.transformsEnabled?!1===s.options.vertical?s.$slideTrack.animate({left:e},s.options.speed,s.options.easing,t):s.$slideTrack.animate({top:e},s.options.speed,s.options.easing,t):!1===s.cssTransitions?(!0===s.options.rtl&&(s.currentLeft=-s.currentLeft),i({animStart:s.currentLeft}).animate({animStart:e},{duration:s.options.speed,easing:s.options.easing,step:function(i){i=Math.ceil(i),!1===s.options.vertical?(o[s.animType]="translate("+i+"px, 0px)",s.$slideTrack.css(o)):(o[s.animType]="translate(0px,"+i+"px)",s.$slideTrack.css(o))},complete:function(){t&&t.call()}})):(s.applyTransition(),e=Math.ceil(e),!1===s.options.vertical?o[s.animType]="translate3d("+e+"px, 0px, 0px)":o[s.animType]="translate3d(0px,"+e+"px, 0px)",s.$slideTrack.css(o),t&&setTimeout(function(){s.disableTransition(),t.call()},s.options.speed))},e.prototype.getNavTarget=function(){var e=this,t=e.options.asNavFor;return t&&null!==t&&(t=i(t).not(e.$slider)),t},e.prototype.asNavFor=function(e){var t=this.getNavTarget();null!==t&&"object"==typeof t&&t.each(function(){var t=i(this).slick("getSlick");t.unslicked||t.slideHandler(e,!0)})},e.prototype.applyTransition=function(i){var e=this,t={};!1===e.options.fade?t[e.transitionType]=e.transformType+" "+e.options.speed+"ms "+e.options.cssEase:t[e.transitionType]="opacity "+e.options.speed+"ms "+e.options.cssEase,!1===e.options.fade?e.$slideTrack.css(t):e.$slides.eq(i).css(t)},e.prototype.autoPlay=function(){var i=this;i.autoPlayClear(),i.slideCount>i.options.slidesToShow&&(i.autoPlayTimer=setInterval(i.autoPlayIterator,i.options.autoplaySpeed))},e.prototype.autoPlayClear=function(){var i=this;i.autoPlayTimer&&clearInterval(i.autoPlayTimer)},e.prototype.autoPlayIterator=function(){var i=this,e=i.currentSlide+i.options.slidesToScroll;i.paused||i.interrupted||i.focussed||(!1===i.options.infinite&&(1===i.direction&&i.currentSlide+1===i.slideCount-1?i.direction=0:0===i.direction&&(e=i.currentSlide-i.options.slidesToScroll,i.currentSlide-1==0&&(i.direction=1))),i.slideHandler(e))},e.prototype.buildArrows=function(){var e=this;!0===e.options.arrows&&(e.$prevArrow=i(e.options.prevArrow).addClass("slick-arrow"),e.$nextArrow=i(e.options.nextArrow).addClass("slick-arrow"),e.slideCount>e.options.slidesToShow?(e.$prevArrow.removeClass("slick-hidden").removeAttr("aria-hidden tabindex"),e.$nextArrow.removeClass("slick-hidden").removeAttr("aria-hidden tabindex"),e.htmlExpr.test(e.options.prevArrow)&&e.$prevArrow.prependTo(e.options.appendArrows),e.htmlExpr.test(e.options.nextArrow)&&e.$nextArrow.appendTo(e.options.appendArrows),!0!==e.options.infinite&&e.$prevArrow.addClass("slick-disabled").attr("aria-disabled","true")):e.$prevArrow.add(e.$nextArrow).addClass("slick-hidden").attr({"aria-disabled":"true",tabindex:"-1"}))},e.prototype.buildDots=function(){var e,t,o=this;if(!0===o.options.dots){for(o.$slider.addClass("slick-dotted"),t=i("<ul />").addClass(o.options.dotsClass),e=0;e<=o.getDotCount();e+=1)t.append(i("<li />").append(o.options.customPaging.call(this,o,e)));o.$dots=t.appendTo(o.options.appendDots),o.$dots.find("li").first().addClass("slick-active")}},e.prototype.buildOut=function(){var e=this;e.$slides=e.$slider.children(e.options.slide+":not(.slick-cloned)").addClass("slick-slide"),e.slideCount=e.$slides.length,e.$slides.each(function(e,t){i(t).attr("data-slick-index",e).data("originalStyling",i(t).attr("style")||"")}),e.$slider.addClass("slick-slider"),e.$slideTrack=0===e.slideCount?i('<div class="slick-track"/>').appendTo(e.$slider):e.$slides.wrapAll('<div class="slick-track"/>').parent(),e.$list=e.$slideTrack.wrap('<div class="slick-list"/>').parent(),e.$slideTrack.css("opacity",0),!0!==e.options.centerMode&&!0!==e.options.swipeToSlide||(e.options.slidesToScroll=1),i("img[data-lazy]",e.$slider).not("[src]").addClass("slick-loading"),e.setupInfinite(),e.buildArrows(),e.buildDots(),e.updateDots(),e.setSlideClasses("number"==typeof e.currentSlide?e.currentSlide:0),!0===e.options.draggable&&e.$list.addClass("draggable")},e.prototype.buildRows=function(){var i,e,t,o,s,n,r,l=this;if(o=document.createDocumentFragment(),n=l.$slider.children(),l.options.rows>1){for(r=l.options.slidesPerRow*l.options.rows,s=Math.ceil(n.length/r),i=0;i<s;i++){var d=document.createElement("div");for(e=0;e<l.options.rows;e++){var a=document.createElement("div");for(t=0;t<l.options.slidesPerRow;t++){var c=i*r+(e*l.options.slidesPerRow+t);n.get(c)&&a.appendChild(n.get(c))}d.appendChild(a)}o.appendChild(d)}l.$slider.empty().append(o),l.$slider.children().children().children().css({width:100/l.options.slidesPerRow+"%",display:"inline-block"})}},e.prototype.checkResponsive=function(e,t){var o,s,n,r=this,l=!1,d=r.$slider.width(),a=window.innerWidth||i(window).width();if("window"===r.respondTo?n=a:"slider"===r.respondTo?n=d:"min"===r.respondTo&&(n=Math.min(a,d)),r.options.responsive&&r.options.responsive.length&&null!==r.options.responsive){s=null;for(o in r.breakpoints)r.breakpoints.hasOwnProperty(o)&&(!1===r.originalSettings.mobileFirst?n<r.breakpoints[o]&&(s=r.breakpoints[o]):n>r.breakpoints[o]&&(s=r.breakpoints[o]));null!==s?null!==r.activeBreakpoint?(s!==r.activeBreakpoint||t)&&(r.activeBreakpoint=s,"unslick"===r.breakpointSettings[s]?r.unslick(s):(r.options=i.extend({},r.originalSettings,r.breakpointSettings[s]),!0===e&&(r.currentSlide=r.options.initialSlide),r.refresh(e)),l=s):(r.activeBreakpoint=s,"unslick"===r.breakpointSettings[s]?r.unslick(s):(r.options=i.extend({},r.originalSettings,r.breakpointSettings[s]),!0===e&&(r.currentSlide=r.options.initialSlide),r.refresh(e)),l=s):null!==r.activeBreakpoint&&(r.activeBreakpoint=null,r.options=r.originalSettings,!0===e&&(r.currentSlide=r.options.initialSlide),r.refresh(e),l=s),e||!1===l||r.$slider.trigger("breakpoint",[r,l])}},e.prototype.changeSlide=function(e,t){var o,s,n,r=this,l=i(e.currentTarget);switch(l.is("a")&&e.preventDefault(),l.is("li")||(l=l.closest("li")),n=r.slideCount%r.options.slidesToScroll!=0,o=n?0:(r.slideCount-r.currentSlide)%r.options.slidesToScroll,e.data.message){case"previous":s=0===o?r.options.slidesToScroll:r.options.slidesToShow-o,r.slideCount>r.options.slidesToShow&&r.slideHandler(r.currentSlide-s,!1,t);break;case"next":s=0===o?r.options.slidesToScroll:o,r.slideCount>r.options.slidesToShow&&r.slideHandler(r.currentSlide+s,!1,t);break;case"index":var d=0===e.data.index?0:e.data.index||l.index()*r.options.slidesToScroll;r.slideHandler(r.checkNavigable(d),!1,t),l.children().trigger("focus");break;default:return}},e.prototype.checkNavigable=function(i){var e,t;if(e=this.getNavigableIndexes(),t=0,i>e[e.length-1])i=e[e.length-1];else for(var o in e){if(i<e[o]){i=t;break}t=e[o]}return i},e.prototype.cleanUpEvents=function(){var e=this;e.options.dots&&null!==e.$dots&&(i("li",e.$dots).off("click.slick",e.changeSlide).off("mouseenter.slick",i.proxy(e.interrupt,e,!0)).off("mouseleave.slick",i.proxy(e.interrupt,e,!1)),!0===e.options.accessibility&&e.$dots.off("keydown.slick",e.keyHandler)),e.$slider.off("focus.slick blur.slick"),!0===e.options.arrows&&e.slideCount>e.options.slidesToShow&&(e.$prevArrow&&e.$prevArrow.off("click.slick",e.changeSlide),e.$nextArrow&&e.$nextArrow.off("click.slick",e.changeSlide),!0===e.options.accessibility&&(e.$prevArrow&&e.$prevArrow.off("keydown.slick",e.keyHandler),e.$nextArrow&&e.$nextArrow.off("keydown.slick",e.keyHandler))),e.$list.off("touchstart.slick mousedown.slick",e.swipeHandler),e.$list.off("touchmove.slick mousemove.slick",e.swipeHandler),e.$list.off("touchend.slick mouseup.slick",e.swipeHandler),e.$list.off("touchcancel.slick mouseleave.slick",e.swipeHandler),e.$list.off("click.slick",e.clickHandler),i(document).off(e.visibilityChange,e.visibility),e.cleanUpSlideEvents(),!0===e.options.accessibility&&e.$list.off("keydown.slick",e.keyHandler),!0===e.options.focusOnSelect&&i(e.$slideTrack).children().off("click.slick",e.selectHandler),i(window).off("orientationchange.slick.slick-"+e.instanceUid,e.orientationChange),i(window).off("resize.slick.slick-"+e.instanceUid,e.resize),i("[draggable!=true]",e.$slideTrack).off("dragstart",e.preventDefault),i(window).off("load.slick.slick-"+e.instanceUid,e.setPosition)},e.prototype.cleanUpSlideEvents=function(){var e=this;e.$list.off("mouseenter.slick",i.proxy(e.interrupt,e,!0)),e.$list.off("mouseleave.slick",i.proxy(e.interrupt,e,!1))},e.prototype.cleanUpRows=function(){var i,e=this;e.options.rows>1&&((i=e.$slides.children().children()).removeAttr("style"),e.$slider.empty().append(i))},e.prototype.clickHandler=function(i){!1===this.shouldClick&&(i.stopImmediatePropagation(),i.stopPropagation(),i.preventDefault())},e.prototype.destroy=function(e){var t=this;t.autoPlayClear(),t.touchObject={},t.cleanUpEvents(),i(".slick-cloned",t.$slider).detach(),t.$dots&&t.$dots.remove(),t.$prevArrow&&t.$prevArrow.length&&(t.$prevArrow.removeClass("slick-disabled slick-arrow slick-hidden").removeAttr("aria-hidden aria-disabled tabindex").css("display",""),t.htmlExpr.test(t.options.prevArrow)&&t.$prevArrow.remove()),t.$nextArrow&&t.$nextArrow.length&&(t.$nextArrow.removeClass("slick-disabled slick-arrow slick-hidden").removeAttr("aria-hidden aria-disabled tabindex").css("display",""),t.htmlExpr.test(t.options.nextArrow)&&t.$nextArrow.remove()),t.$slides&&(t.$slides.removeClass("slick-slide slick-active slick-center slick-visible slick-current").removeAttr("aria-hidden").removeAttr("data-slick-index").each(function(){i(this).attr("style",i(this).data("originalStyling"))}),t.$slideTrack.children(this.options.slide).detach(),t.$slideTrack.detach(),t.$list.detach(),t.$slider.append(t.$slides)),t.cleanUpRows(),t.$slider.removeClass("slick-slider"),t.$slider.removeClass("slick-initialized"),t.$slider.removeClass("slick-dotted"),t.unslicked=!0,e||t.$slider.trigger("destroy",[t])},e.prototype.disableTransition=function(i){var e=this,t={};t[e.transitionType]="",!1===e.options.fade?e.$slideTrack.css(t):e.$slides.eq(i).css(t)},e.prototype.fadeSlide=function(i,e){var t=this;!1===t.cssTransitions?(t.$slides.eq(i).css({zIndex:t.options.zIndex}),t.$slides.eq(i).animate({opacity:1},t.options.speed,t.options.easing,e)):(t.applyTransition(i),t.$slides.eq(i).css({opacity:1,zIndex:t.options.zIndex}),e&&setTimeout(function(){t.disableTransition(i),e.call()},t.options.speed))},e.prototype.fadeSlideOut=function(i){var e=this;!1===e.cssTransitions?e.$slides.eq(i).animate({opacity:0,zIndex:e.options.zIndex-2},e.options.speed,e.options.easing):(e.applyTransition(i),e.$slides.eq(i).css({opacity:0,zIndex:e.options.zIndex-2}))},e.prototype.filterSlides=e.prototype.slickFilter=function(i){var e=this;null!==i&&(e.$slidesCache=e.$slides,e.unload(),e.$slideTrack.children(this.options.slide).detach(),e.$slidesCache.filter(i).appendTo(e.$slideTrack),e.reinit())},e.prototype.focusHandler=function(){var e=this;e.$slider.off("focus.slick blur.slick").on("focus.slick blur.slick","*",function(t){t.stopImmediatePropagation();var o=i(this);setTimeout(function(){e.options.pauseOnFocus&&(e.focussed=o.is(":focus"),e.autoPlay())},0)})},e.prototype.getCurrent=e.prototype.slickCurrentSlide=function(){return this.currentSlide},e.prototype.getDotCount=function(){var i=this,e=0,t=0,o=0;if(!0===i.options.infinite)if(i.slideCount<=i.options.slidesToShow)++o;else for(;e<i.slideCount;)++o,e=t+i.options.slidesToScroll,t+=i.options.slidesToScroll<=i.options.slidesToShow?i.options.slidesToScroll:i.options.slidesToShow;else if(!0===i.options.centerMode)o=i.slideCount;else if(i.options.asNavFor)for(;e<i.slideCount;)++o,e=t+i.options.slidesToScroll,t+=i.options.slidesToScroll<=i.options.slidesToShow?i.options.slidesToScroll:i.options.slidesToShow;else o=1+Math.ceil((i.slideCount-i.options.slidesToShow)/i.options.slidesToScroll);return o-1},e.prototype.getLeft=function(i){var e,t,o,s,n=this,r=0;return n.slideOffset=0,t=n.$slides.first().outerHeight(!0),!0===n.options.infinite?(n.slideCount>n.options.slidesToShow&&(n.slideOffset=n.slideWidth*n.options.slidesToShow*-1,s=-1,!0===n.options.vertical&&!0===n.options.centerMode&&(2===n.options.slidesToShow?s=-1.5:1===n.options.slidesToShow&&(s=-2)),r=t*n.options.slidesToShow*s),n.slideCount%n.options.slidesToScroll!=0&&i+n.options.slidesToScroll>n.slideCount&&n.slideCount>n.options.slidesToShow&&(i>n.slideCount?(n.slideOffset=(n.options.slidesToShow-(i-n.slideCount))*n.slideWidth*-1,r=(n.options.slidesToShow-(i-n.slideCount))*t*-1):(n.slideOffset=n.slideCount%n.options.slidesToScroll*n.slideWidth*-1,r=n.slideCount%n.options.slidesToScroll*t*-1))):i+n.options.slidesToShow>n.slideCount&&(n.slideOffset=(i+n.options.slidesToShow-n.slideCount)*n.slideWidth,r=(i+n.options.slidesToShow-n.slideCount)*t),n.slideCount<=n.options.slidesToShow&&(n.slideOffset=0,r=0),!0===n.options.centerMode&&n.slideCount<=n.options.slidesToShow?n.slideOffset=n.slideWidth*Math.floor(n.options.slidesToShow)/2-n.slideWidth*n.slideCount/2:!0===n.options.centerMode&&!0===n.options.infinite?n.slideOffset+=n.slideWidth*Math.floor(n.options.slidesToShow/2)-n.slideWidth:!0===n.options.centerMode&&(n.slideOffset=0,n.slideOffset+=n.slideWidth*Math.floor(n.options.slidesToShow/2)),e=!1===n.options.vertical?i*n.slideWidth*-1+n.slideOffset:i*t*-1+r,!0===n.options.variableWidth&&(o=n.slideCount<=n.options.slidesToShow||!1===n.options.infinite?n.$slideTrack.children(".slick-slide").eq(i):n.$slideTrack.children(".slick-slide").eq(i+n.options.slidesToShow),e=!0===n.options.rtl?o[0]?-1*(n.$slideTrack.width()-o[0].offsetLeft-o.width()):0:o[0]?-1*o[0].offsetLeft:0,!0===n.options.centerMode&&(o=n.slideCount<=n.options.slidesToShow||!1===n.options.infinite?n.$slideTrack.children(".slick-slide").eq(i):n.$slideTrack.children(".slick-slide").eq(i+n.options.slidesToShow+1),e=!0===n.options.rtl?o[0]?-1*(n.$slideTrack.width()-o[0].offsetLeft-o.width()):0:o[0]?-1*o[0].offsetLeft:0,e+=(n.$list.width()-o.outerWidth())/2)),e},e.prototype.getOption=e.prototype.slickGetOption=function(i){return this.options[i]},e.prototype.getNavigableIndexes=function(){var i,e=this,t=0,o=0,s=[];for(!1===e.options.infinite?i=e.slideCount:(t=-1*e.options.slidesToScroll,o=-1*e.options.slidesToScroll,i=2*e.slideCount);t<i;)s.push(t),t=o+e.options.slidesToScroll,o+=e.options.slidesToScroll<=e.options.slidesToShow?e.options.slidesToScroll:e.options.slidesToShow;return s},e.prototype.getSlick=function(){return this},e.prototype.getSlideCount=function(){var e,t,o=this;return t=!0===o.options.centerMode?o.slideWidth*Math.floor(o.options.slidesToShow/2):0,!0===o.options.swipeToSlide?(o.$slideTrack.find(".slick-slide").each(function(s,n){if(n.offsetLeft-t+i(n).outerWidth()/2>-1*o.swipeLeft)return e=n,!1}),Math.abs(i(e).attr("data-slick-index")-o.currentSlide)||1):o.options.slidesToScroll},e.prototype.goTo=e.prototype.slickGoTo=function(i,e){this.changeSlide({data:{message:"index",index:parseInt(i)}},e)},e.prototype.init=function(e){var t=this;i(t.$slider).hasClass("slick-initialized")||(i(t.$slider).addClass("slick-initialized"),t.buildRows(),t.buildOut(),t.setProps(),t.startLoad(),t.loadSlider(),t.initializeEvents(),t.updateArrows(),t.updateDots(),t.checkResponsive(!0),t.focusHandler()),e&&t.$slider.trigger("init",[t]),!0===t.options.accessibility&&t.initADA(),t.options.autoplay&&(t.paused=!1,t.autoPlay())},e.prototype.initADA=function(){var e=this,t=Math.ceil(e.slideCount/e.options.slidesToShow),o=e.getNavigableIndexes().filter(function(i){return i>=0&&i<e.slideCount});e.$slides.add(e.$slideTrack.find(".slick-cloned")).attr({"aria-hidden":"true",tabindex:"-1"}).find("a, input, button, select").attr({tabindex:"-1"}),null!==e.$dots&&(e.$slides.not(e.$slideTrack.find(".slick-cloned")).each(function(t){var s=o.indexOf(t);i(this).attr({role:"tabpanel",id:"slick-slide"+e.instanceUid+t,tabindex:-1}),-1!==s&&i(this).attr({"aria-describedby":"slick-slide-control"+e.instanceUid+s})}),e.$dots.attr("role","tablist").find("li").each(function(s){var n=o[s];i(this).attr({role:"presentation"}),i(this).find("button").first().attr({role:"tab",id:"slick-slide-control"+e.instanceUid+s,"aria-controls":"slick-slide"+e.instanceUid+n,"aria-label":s+1+" of "+t,"aria-selected":null,tabindex:"-1"})}).eq(e.currentSlide).find("button").attr({"aria-selected":"true",tabindex:"0"}).end());for(var s=e.currentSlide,n=s+e.options.slidesToShow;s<n;s++)e.$slides.eq(s).attr("tabindex",0);e.activateADA()},e.prototype.initArrowEvents=function(){var i=this;!0===i.options.arrows&&i.slideCount>i.options.slidesToShow&&(i.$prevArrow.off("click.slick").on("click.slick",{message:"previous"},i.changeSlide),i.$nextArrow.off("click.slick").on("click.slick",{message:"next"},i.changeSlide),!0===i.options.accessibility&&(i.$prevArrow.on("keydown.slick",i.keyHandler),i.$nextArrow.on("keydown.slick",i.keyHandler)))},e.prototype.initDotEvents=function(){var e=this;!0===e.options.dots&&(i("li",e.$dots).on("click.slick",{message:"index"},e.changeSlide),!0===e.options.accessibility&&e.$dots.on("keydown.slick",e.keyHandler)),!0===e.options.dots&&!0===e.options.pauseOnDotsHover&&i("li",e.$dots).on("mouseenter.slick",i.proxy(e.interrupt,e,!0)).on("mouseleave.slick",i.proxy(e.interrupt,e,!1))},e.prototype.initSlideEvents=function(){var e=this;e.options.pauseOnHover&&(e.$list.on("mouseenter.slick",i.proxy(e.interrupt,e,!0)),e.$list.on("mouseleave.slick",i.proxy(e.interrupt,e,!1)))},e.prototype.initializeEvents=function(){var e=this;e.initArrowEvents(),e.initDotEvents(),e.initSlideEvents(),e.$list.on("touchstart.slick mousedown.slick",{action:"start"},e.swipeHandler),e.$list.on("touchmove.slick mousemove.slick",{action:"move"},e.swipeHandler),e.$list.on("touchend.slick mouseup.slick",{action:"end"},e.swipeHandler),e.$list.on("touchcancel.slick mouseleave.slick",{action:"end"},e.swipeHandler),e.$list.on("click.slick",e.clickHandler),i(document).on(e.visibilityChange,i.proxy(e.visibility,e)),!0===e.options.accessibility&&e.$list.on("keydown.slick",e.keyHandler),!0===e.options.focusOnSelect&&i(e.$slideTrack).children().on("click.slick",e.selectHandler),i(window).on("orientationchange.slick.slick-"+e.instanceUid,i.proxy(e.orientationChange,e)),i(window).on("resize.slick.slick-"+e.instanceUid,i.proxy(e.resize,e)),i("[draggable!=true]",e.$slideTrack).on("dragstart",e.preventDefault),i(window).on("load.slick.slick-"+e.instanceUid,e.setPosition),i(e.setPosition)},e.prototype.initUI=function(){var i=this;!0===i.options.arrows&&i.slideCount>i.options.slidesToShow&&(i.$prevArrow.show(),i.$nextArrow.show()),!0===i.options.dots&&i.slideCount>i.options.slidesToShow&&i.$dots.show()},e.prototype.keyHandler=function(i){var e=this;i.target.tagName.match("TEXTAREA|INPUT|SELECT")||(37===i.keyCode&&!0===e.options.accessibility?e.changeSlide({data:{message:!0===e.options.rtl?"next":"previous"}}):39===i.keyCode&&!0===e.options.accessibility&&e.changeSlide({data:{message:!0===e.options.rtl?"previous":"next"}}))},e.prototype.lazyLoad=function(){function e(e){i("img[data-lazy]",e).each(function(){var e=i(this),t=i(this).attr("data-lazy"),o=i(this).attr("data-srcset"),s=i(this).attr("data-sizes")||n.$slider.attr("data-sizes"),r=document.createElement("img");r.onload=function(){e.animate({opacity:0},100,function(){o&&(e.attr("srcset",o),s&&e.attr("sizes",s)),e.attr("src",t).animate({opacity:1},200,function(){e.removeAttr("data-lazy data-srcset data-sizes").removeClass("slick-loading")}),n.$slider.trigger("lazyLoaded",[n,e,t])})},r.onerror=function(){e.removeAttr("data-lazy").removeClass("slick-loading").addClass("slick-lazyload-error"),n.$slider.trigger("lazyLoadError",[n,e,t])},r.src=t})}var t,o,s,n=this;if(!0===n.options.centerMode?!0===n.options.infinite?s=(o=n.currentSlide+(n.options.slidesToShow/2+1))+n.options.slidesToShow+2:(o=Math.max(0,n.currentSlide-(n.options.slidesToShow/2+1)),s=n.options.slidesToShow/2+1+2+n.currentSlide):(o=n.options.infinite?n.options.slidesToShow+n.currentSlide:n.currentSlide,s=Math.ceil(o+n.options.slidesToShow),!0===n.options.fade&&(o>0&&o--,s<=n.slideCount&&s++)),t=n.$slider.find(".slick-slide").slice(o,s),"anticipated"===n.options.lazyLoad)for(var r=o-1,l=s,d=n.$slider.find(".slick-slide"),a=0;a<n.options.slidesToScroll;a++)r<0&&(r=n.slideCount-1),t=(t=t.add(d.eq(r))).add(d.eq(l)),r--,l++;e(t),n.slideCount<=n.options.slidesToShow?e(n.$slider.find(".slick-slide")):n.currentSlide>=n.slideCount-n.options.slidesToShow?e(n.$slider.find(".slick-cloned").slice(0,n.options.slidesToShow)):0===n.currentSlide&&e(n.$slider.find(".slick-cloned").slice(-1*n.options.slidesToShow))},e.prototype.loadSlider=function(){var i=this;i.setPosition(),i.$slideTrack.css({opacity:1}),i.$slider.removeClass("slick-loading"),i.initUI(),"progressive"===i.options.lazyLoad&&i.progressiveLazyLoad()},e.prototype.next=e.prototype.slickNext=function(){this.changeSlide({data:{message:"next"}})},e.prototype.orientationChange=function(){var i=this;i.checkResponsive(),i.setPosition()},e.prototype.pause=e.prototype.slickPause=function(){var i=this;i.autoPlayClear(),i.paused=!0},e.prototype.play=e.prototype.slickPlay=function(){var i=this;i.autoPlay(),i.options.autoplay=!0,i.paused=!1,i.focussed=!1,i.interrupted=!1},e.prototype.postSlide=function(e){var t=this;t.unslicked||(t.$slider.trigger("afterChange",[t,e]),t.animating=!1,t.slideCount>t.options.slidesToShow&&t.setPosition(),t.swipeLeft=null,t.options.autoplay&&t.autoPlay(),!0===t.options.accessibility&&(t.initADA(),t.options.focusOnChange&&i(t.$slides.get(t.currentSlide)).attr("tabindex",0).focus()))},e.prototype.prev=e.prototype.slickPrev=function(){this.changeSlide({data:{message:"previous"}})},e.prototype.preventDefault=function(i){i.preventDefault()},e.prototype.progressiveLazyLoad=function(e){e=e||1;var t,o,s,n,r,l=this,d=i("img[data-lazy]",l.$slider);d.length?(t=d.first(),o=t.attr("data-lazy"),s=t.attr("data-srcset"),n=t.attr("data-sizes")||l.$slider.attr("data-sizes"),(r=document.createElement("img")).onload=function(){s&&(t.attr("srcset",s),n&&t.attr("sizes",n)),t.attr("src",o).removeAttr("data-lazy data-srcset data-sizes").removeClass("slick-loading"),!0===l.options.adaptiveHeight&&l.setPosition(),l.$slider.trigger("lazyLoaded",[l,t,o]),l.progressiveLazyLoad()},r.onerror=function(){e<3?setTimeout(function(){l.progressiveLazyLoad(e+1)},500):(t.removeAttr("data-lazy").removeClass("slick-loading").addClass("slick-lazyload-error"),l.$slider.trigger("lazyLoadError",[l,t,o]),l.progressiveLazyLoad())},r.src=o):l.$slider.trigger("allImagesLoaded",[l])},e.prototype.refresh=function(e){var t,o,s=this;o=s.slideCount-s.options.slidesToShow,!s.options.infinite&&s.currentSlide>o&&(s.currentSlide=o),s.slideCount<=s.options.slidesToShow&&(s.currentSlide=0),t=s.currentSlide,s.destroy(!0),i.extend(s,s.initials,{currentSlide:t}),s.init(),e||s.changeSlide({data:{message:"index",index:t}},!1)},e.prototype.registerBreakpoints=function(){var e,t,o,s=this,n=s.options.responsive||null;if("array"===i.type(n)&&n.length){s.respondTo=s.options.respondTo||"window";for(e in n)if(o=s.breakpoints.length-1,n.hasOwnProperty(e)){for(t=n[e].breakpoint;o>=0;)s.breakpoints[o]&&s.breakpoints[o]===t&&s.breakpoints.splice(o,1),o--;s.breakpoints.push(t),s.breakpointSettings[t]=n[e].settings}s.breakpoints.sort(function(i,e){return s.options.mobileFirst?i-e:e-i})}},e.prototype.reinit=function(){var e=this;e.$slides=e.$slideTrack.children(e.options.slide).addClass("slick-slide"),e.slideCount=e.$slides.length,e.currentSlide>=e.slideCount&&0!==e.currentSlide&&(e.currentSlide=e.currentSlide-e.options.slidesToScroll),e.slideCount<=e.options.slidesToShow&&(e.currentSlide=0),e.registerBreakpoints(),e.setProps(),e.setupInfinite(),e.buildArrows(),e.updateArrows(),e.initArrowEvents(),e.buildDots(),e.updateDots(),e.initDotEvents(),e.cleanUpSlideEvents(),e.initSlideEvents(),e.checkResponsive(!1,!0),!0===e.options.focusOnSelect&&i(e.$slideTrack).children().on("click.slick",e.selectHandler),e.setSlideClasses("number"==typeof e.currentSlide?e.currentSlide:0),e.setPosition(),e.focusHandler(),e.paused=!e.options.autoplay,e.autoPlay(),e.$slider.trigger("reInit",[e])},e.prototype.resize=function(){var e=this;i(window).width()!==e.windowWidth&&(clearTimeout(e.windowDelay),e.windowDelay=window.setTimeout(function(){e.windowWidth=i(window).width(),e.checkResponsive(),e.unslicked||e.setPosition()},50))},e.prototype.removeSlide=e.prototype.slickRemove=function(i,e,t){var o=this;if(i="boolean"==typeof i?!0===(e=i)?0:o.slideCount-1:!0===e?--i:i,o.slideCount<1||i<0||i>o.slideCount-1)return!1;o.unload(),!0===t?o.$slideTrack.children().remove():o.$slideTrack.children(this.options.slide).eq(i).remove(),o.$slides=o.$slideTrack.children(this.options.slide),o.$slideTrack.children(this.options.slide).detach(),o.$slideTrack.append(o.$slides),o.$slidesCache=o.$slides,o.reinit()},e.prototype.setCSS=function(i){var e,t,o=this,s={};!0===o.options.rtl&&(i=-i),e="left"==o.positionProp?Math.ceil(i)+"px":"0px",t="top"==o.positionProp?Math.ceil(i)+"px":"0px",s[o.positionProp]=i,!1===o.transformsEnabled?o.$slideTrack.css(s):(s={},!1===o.cssTransitions?(s[o.animType]="translate("+e+", "+t+")",o.$slideTrack.css(s)):(s[o.animType]="translate3d("+e+", "+t+", 0px)",o.$slideTrack.css(s)))},e.prototype.setDimensions=function(){var i=this;!1===i.options.vertical?!0===i.options.centerMode&&i.$list.css({padding:"0px "+i.options.centerPadding}):(i.$list.height(i.$slides.first().outerHeight(!0)*i.options.slidesToShow),!0===i.options.centerMode&&i.$list.css({padding:i.options.centerPadding+" 0px"})),i.listWidth=i.$list.width(),i.listHeight=i.$list.height(),!1===i.options.vertical&&!1===i.options.variableWidth?(i.slideWidth=Math.ceil(i.listWidth/i.options.slidesToShow),i.$slideTrack.width(Math.ceil(i.slideWidth*i.$slideTrack.children(".slick-slide").length))):!0===i.options.variableWidth?i.$slideTrack.width(5e3*i.slideCount):(i.slideWidth=Math.ceil(i.listWidth),i.$slideTrack.height(Math.ceil(i.$slides.first().outerHeight(!0)*i.$slideTrack.children(".slick-slide").length)));var e=i.$slides.first().outerWidth(!0)-i.$slides.first().width();!1===i.options.variableWidth&&i.$slideTrack.children(".slick-slide").width(i.slideWidth-e)},e.prototype.setFade=function(){var e,t=this;t.$slides.each(function(o,s){e=t.slideWidth*o*-1,!0===t.options.rtl?i(s).css({position:"relative",right:e,top:0,zIndex:t.options.zIndex-2,opacity:0}):i(s).css({position:"relative",left:e,top:0,zIndex:t.options.zIndex-2,opacity:0})}),t.$slides.eq(t.currentSlide).css({zIndex:t.options.zIndex-1,opacity:1})},e.prototype.setHeight=function(){var i=this;if(1===i.options.slidesToShow&&!0===i.options.adaptiveHeight&&!1===i.options.vertical){var e=i.$slides.eq(i.currentSlide).outerHeight(!0);i.$list.css("height",e)}},e.prototype.setOption=e.prototype.slickSetOption=function(){var e,t,o,s,n,r=this,l=!1;if("object"===i.type(arguments[0])?(o=arguments[0],l=arguments[1],n="multiple"):"string"===i.type(arguments[0])&&(o=arguments[0],s=arguments[1],l=arguments[2],"responsive"===arguments[0]&&"array"===i.type(arguments[1])?n="responsive":void 0!==arguments[1]&&(n="single")),"single"===n)r.options[o]=s;else if("multiple"===n)i.each(o,function(i,e){r.options[i]=e});else if("responsive"===n)for(t in s)if("array"!==i.type(r.options.responsive))r.options.responsive=[s[t]];else{for(e=r.options.responsive.length-1;e>=0;)r.options.responsive[e].breakpoint===s[t].breakpoint&&r.options.responsive.splice(e,1),e--;r.options.responsive.push(s[t])}l&&(r.unload(),r.reinit())},e.prototype.setPosition=function(){var i=this;i.setDimensions(),i.setHeight(),!1===i.options.fade?i.setCSS(i.getLeft(i.currentSlide)):i.setFade(),i.$slider.trigger("setPosition",[i])},e.prototype.setProps=function(){var i=this,e=document.body.style;i.positionProp=!0===i.options.vertical?"top":"left","top"===i.positionProp?i.$slider.addClass("slick-vertical"):i.$slider.removeClass("slick-vertical"),void 0===e.WebkitTransition&&void 0===e.MozTransition&&void 0===e.msTransition||!0===i.options.useCSS&&(i.cssTransitions=!0),i.options.fade&&("number"==typeof i.options.zIndex?i.options.zIndex<3&&(i.options.zIndex=3):i.options.zIndex=i.defaults.zIndex),void 0!==e.OTransform&&(i.animType="OTransform",i.transformType="-o-transform",i.transitionType="OTransition",void 0===e.perspectiveProperty&&void 0===e.webkitPerspective&&(i.animType=!1)),void 0!==e.MozTransform&&(i.animType="MozTransform",i.transformType="-moz-transform",i.transitionType="MozTransition",void 0===e.perspectiveProperty&&void 0===e.MozPerspective&&(i.animType=!1)),void 0!==e.webkitTransform&&(i.animType="webkitTransform",i.transformType="-webkit-transform",i.transitionType="webkitTransition",void 0===e.perspectiveProperty&&void 0===e.webkitPerspective&&(i.animType=!1)),void 0!==e.msTransform&&(i.animType="msTransform",i.transformType="-ms-transform",i.transitionType="msTransition",void 0===e.msTransform&&(i.animType=!1)),void 0!==e.transform&&!1!==i.animType&&(i.animType="transform",i.transformType="transform",i.transitionType="transition"),i.transformsEnabled=i.options.useTransform&&null!==i.animType&&!1!==i.animType},e.prototype.setSlideClasses=function(i){var e,t,o,s,n=this;if(t=n.$slider.find(".slick-slide").removeClass("slick-active slick-center slick-current").attr("aria-hidden","true"),n.$slides.eq(i).addClass("slick-current"),!0===n.options.centerMode){var r=n.options.slidesToShow%2==0?1:0;e=Math.floor(n.options.slidesToShow/2),!0===n.options.infinite&&(i>=e&&i<=n.slideCount-1-e?n.$slides.slice(i-e+r,i+e+1).addClass("slick-active").attr("aria-hidden","false"):(o=n.options.slidesToShow+i,t.slice(o-e+1+r,o+e+2).addClass("slick-active").attr("aria-hidden","false")),0===i?t.eq(t.length-1-n.options.slidesToShow).addClass("slick-center"):i===n.slideCount-1&&t.eq(n.options.slidesToShow).addClass("slick-center")),n.$slides.eq(i).addClass("slick-center")}else i>=0&&i<=n.slideCount-n.options.slidesToShow?n.$slides.slice(i,i+n.options.slidesToShow).addClass("slick-active").attr("aria-hidden","false"):t.length<=n.options.slidesToShow?t.addClass("slick-active").attr("aria-hidden","false"):(s=n.slideCount%n.options.slidesToShow,o=!0===n.options.infinite?n.options.slidesToShow+i:i,n.options.slidesToShow==n.options.slidesToScroll&&n.slideCount-i<n.options.slidesToShow?t.slice(o-(n.options.slidesToShow-s),o+s).addClass("slick-active").attr("aria-hidden","false"):t.slice(o,o+n.options.slidesToShow).addClass("slick-active").attr("aria-hidden","false"));"ondemand"!==n.options.lazyLoad&&"anticipated"!==n.options.lazyLoad||n.lazyLoad()},e.prototype.setupInfinite=function(){var e,t,o,s=this;if(!0===s.options.fade&&(s.options.centerMode=!1),!0===s.options.infinite&&!1===s.options.fade&&(t=null,s.slideCount>s.options.slidesToShow)){for(o=!0===s.options.centerMode?s.options.slidesToShow+1:s.options.slidesToShow,e=s.slideCount;e>s.slideCount-o;e-=1)t=e-1,i(s.$slides[t]).clone(!0).attr("id","").attr("data-slick-index",t-s.slideCount).prependTo(s.$slideTrack).addClass("slick-cloned");for(e=0;e<o+s.slideCount;e+=1)t=e,i(s.$slides[t]).clone(!0).attr("id","").attr("data-slick-index",t+s.slideCount).appendTo(s.$slideTrack).addClass("slick-cloned");s.$slideTrack.find(".slick-cloned").find("[id]").each(function(){i(this).attr("id","")})}},e.prototype.interrupt=function(i){var e=this;i||e.autoPlay(),e.interrupted=i},e.prototype.selectHandler=function(e){var t=this,o=i(e.target).is(".slick-slide")?i(e.target):i(e.target).parents(".slick-slide"),s=parseInt(o.attr("data-slick-index"));s||(s=0),t.slideCount<=t.options.slidesToShow?t.slideHandler(s,!1,!0):t.slideHandler(s)},e.prototype.slideHandler=function(i,e,t){var o,s,n,r,l,d=null,a=this;if(e=e||!1,!(!0===a.animating&&!0===a.options.waitForAnimate||!0===a.options.fade&&a.currentSlide===i))if(!1===e&&a.asNavFor(i),o=i,d=a.getLeft(o),r=a.getLeft(a.currentSlide),a.currentLeft=null===a.swipeLeft?r:a.swipeLeft,!1===a.options.infinite&&!1===a.options.centerMode&&(i<0||i>a.getDotCount()*a.options.slidesToScroll))!1===a.options.fade&&(o=a.currentSlide,!0!==t?a.animateSlide(r,function(){a.postSlide(o)}):a.postSlide(o));else if(!1===a.options.infinite&&!0===a.options.centerMode&&(i<0||i>a.slideCount-a.options.slidesToScroll))!1===a.options.fade&&(o=a.currentSlide,!0!==t?a.animateSlide(r,function(){a.postSlide(o)}):a.postSlide(o));else{if(a.options.autoplay&&clearInterval(a.autoPlayTimer),s=o<0?a.slideCount%a.options.slidesToScroll!=0?a.slideCount-a.slideCount%a.options.slidesToScroll:a.slideCount+o:o>=a.slideCount?a.slideCount%a.options.slidesToScroll!=0?0:o-a.slideCount:o,a.animating=!0,a.$slider.trigger("beforeChange",[a,a.currentSlide,s]),n=a.currentSlide,a.currentSlide=s,a.setSlideClasses(a.currentSlide),a.options.asNavFor&&(l=(l=a.getNavTarget()).slick("getSlick")).slideCount<=l.options.slidesToShow&&l.setSlideClasses(a.currentSlide),a.updateDots(),a.updateArrows(),!0===a.options.fade)return!0!==t?(a.fadeSlideOut(n),a.fadeSlide(s,function(){a.postSlide(s)})):a.postSlide(s),void a.animateHeight();!0!==t?a.animateSlide(d,function(){a.postSlide(s)}):a.postSlide(s)}},e.prototype.startLoad=function(){var i=this;!0===i.options.arrows&&i.slideCount>i.options.slidesToShow&&(i.$prevArrow.hide(),i.$nextArrow.hide()),!0===i.options.dots&&i.slideCount>i.options.slidesToShow&&i.$dots.hide(),i.$slider.addClass("slick-loading")},e.prototype.swipeDirection=function(){var i,e,t,o,s=this;return i=s.touchObject.startX-s.touchObject.curX,e=s.touchObject.startY-s.touchObject.curY,t=Math.atan2(e,i),(o=Math.round(180*t/Math.PI))<0&&(o=360-Math.abs(o)),o<=45&&o>=0?!1===s.options.rtl?"left":"right":o<=360&&o>=315?!1===s.options.rtl?"left":"right":o>=135&&o<=225?!1===s.options.rtl?"right":"left":!0===s.options.verticalSwiping?o>=35&&o<=135?"down":"up":"vertical"},e.prototype.swipeEnd=function(i){var e,t,o=this;if(o.dragging=!1,o.swiping=!1,o.scrolling)return o.scrolling=!1,!1;if(o.interrupted=!1,o.shouldClick=!(o.touchObject.swipeLength>10),void 0===o.touchObject.curX)return!1;if(!0===o.touchObject.edgeHit&&o.$slider.trigger("edge",[o,o.swipeDirection()]),o.touchObject.swipeLength>=o.touchObject.minSwipe){switch(t=o.swipeDirection()){case"left":case"down":e=o.options.swipeToSlide?o.checkNavigable(o.currentSlide+o.getSlideCount()):o.currentSlide+o.getSlideCount(),o.currentDirection=0;break;case"right":case"up":e=o.options.swipeToSlide?o.checkNavigable(o.currentSlide-o.getSlideCount()):o.currentSlide-o.getSlideCount(),o.currentDirection=1}"vertical"!=t&&(o.slideHandler(e),o.touchObject={},o.$slider.trigger("swipe",[o,t]))}else o.touchObject.startX!==o.touchObject.curX&&(o.slideHandler(o.currentSlide),o.touchObject={})},e.prototype.swipeHandler=function(i){var e=this;if(!(!1===e.options.swipe||"ontouchend"in document&&!1===e.options.swipe||!1===e.options.draggable&&-1!==i.type.indexOf("mouse")))switch(e.touchObject.fingerCount=i.originalEvent&&void 0!==i.originalEvent.touches?i.originalEvent.touches.length:1,e.touchObject.minSwipe=e.listWidth/e.options.touchThreshold,!0===e.options.verticalSwiping&&(e.touchObject.minSwipe=e.listHeight/e.options.touchThreshold),i.data.action){case"start":e.swipeStart(i);break;case"move":e.swipeMove(i);break;case"end":e.swipeEnd(i)}},e.prototype.swipeMove=function(i){var e,t,o,s,n,r,l=this;return n=void 0!==i.originalEvent?i.originalEvent.touches:null,!(!l.dragging||l.scrolling||n&&1!==n.length)&&(e=l.getLeft(l.currentSlide),l.touchObject.curX=void 0!==n?n[0].pageX:i.clientX,l.touchObject.curY=void 0!==n?n[0].pageY:i.clientY,l.touchObject.swipeLength=Math.round(Math.sqrt(Math.pow(l.touchObject.curX-l.touchObject.startX,2))),r=Math.round(Math.sqrt(Math.pow(l.touchObject.curY-l.touchObject.startY,2))),!l.options.verticalSwiping&&!l.swiping&&r>4?(l.scrolling=!0,!1):(!0===l.options.verticalSwiping&&(l.touchObject.swipeLength=r),t=l.swipeDirection(),void 0!==i.originalEvent&&l.touchObject.swipeLength>4&&(l.swiping=!0,i.preventDefault()),s=(!1===l.options.rtl?1:-1)*(l.touchObject.curX>l.touchObject.startX?1:-1),!0===l.options.verticalSwiping&&(s=l.touchObject.curY>l.touchObject.startY?1:-1),o=l.touchObject.swipeLength,l.touchObject.edgeHit=!1,!1===l.options.infinite&&(0===l.currentSlide&&"right"===t||l.currentSlide>=l.getDotCount()&&"left"===t)&&(o=l.touchObject.swipeLength*l.options.edgeFriction,l.touchObject.edgeHit=!0),!1===l.options.vertical?l.swipeLeft=e+o*s:l.swipeLeft=e+o*(l.$list.height()/l.listWidth)*s,!0===l.options.verticalSwiping&&(l.swipeLeft=e+o*s),!0!==l.options.fade&&!1!==l.options.touchMove&&(!0===l.animating?(l.swipeLeft=null,!1):void l.setCSS(l.swipeLeft))))},e.prototype.swipeStart=function(i){var e,t=this;if(t.interrupted=!0,1!==t.touchObject.fingerCount||t.slideCount<=t.options.slidesToShow)return t.touchObject={},!1;void 0!==i.originalEvent&&void 0!==i.originalEvent.touches&&(e=i.originalEvent.touches[0]),t.touchObject.startX=t.touchObject.curX=void 0!==e?e.pageX:i.clientX,t.touchObject.startY=t.touchObject.curY=void 0!==e?e.pageY:i.clientY,t.dragging=!0},e.prototype.unfilterSlides=e.prototype.slickUnfilter=function(){var i=this;null!==i.$slidesCache&&(i.unload(),i.$slideTrack.children(this.options.slide).detach(),i.$slidesCache.appendTo(i.$slideTrack),i.reinit())},e.prototype.unload=function(){var e=this;i(".slick-cloned",e.$slider).remove(),e.$dots&&e.$dots.remove(),e.$prevArrow&&e.htmlExpr.test(e.options.prevArrow)&&e.$prevArrow.remove(),e.$nextArrow&&e.htmlExpr.test(e.options.nextArrow)&&e.$nextArrow.remove(),e.$slides.removeClass("slick-slide slick-active slick-visible slick-current").attr("aria-hidden","true").css("width","")},e.prototype.unslick=function(i){var e=this;e.$slider.trigger("unslick",[e,i]),e.destroy()},e.prototype.updateArrows=function(){var i=this;Math.floor(i.options.slidesToShow/2),!0===i.options.arrows&&i.slideCount>i.options.slidesToShow&&!i.options.infinite&&(i.$prevArrow.removeClass("slick-disabled").attr("aria-disabled","false"),i.$nextArrow.removeClass("slick-disabled").attr("aria-disabled","false"),0===i.currentSlide?(i.$prevArrow.addClass("slick-disabled").attr("aria-disabled","true"),i.$nextArrow.removeClass("slick-disabled").attr("aria-disabled","false")):i.currentSlide>=i.slideCount-i.options.slidesToShow&&!1===i.options.centerMode?(i.$nextArrow.addClass("slick-disabled").attr("aria-disabled","true"),i.$prevArrow.removeClass("slick-disabled").attr("aria-disabled","false")):i.currentSlide>=i.slideCount-1&&!0===i.options.centerMode&&(i.$nextArrow.addClass("slick-disabled").attr("aria-disabled","true"),i.$prevArrow.removeClass("slick-disabled").attr("aria-disabled","false")))},e.prototype.updateDots=function(){var i=this;null!==i.$dots&&(i.$dots.find("li").removeClass("slick-active").end(),i.$dots.find("li").eq(Math.floor(i.currentSlide/i.options.slidesToScroll)).addClass("slick-active"))},e.prototype.visibility=function(){var i=this;i.options.autoplay&&(document[i.hidden]?i.interrupted=!0:i.interrupted=!1)},i.fn.slick=function(){var i,t,o=this,s=arguments[0],n=Array.prototype.slice.call(arguments,1),r=o.length;for(i=0;i<r;i++)if("object"==typeof s||void 0===s?o[i].slick=new e(o[i],s):t=o[i].slick[s].apply(o[i].slick,n),void 0!==t)return t;return o}});


var icsFormatter = function() {
    'use strict';

    if (navigator.userAgent.indexOf('MSIE') > -1 && navigator.userAgent.indexOf('MSIE 10') == -1) {
        console.log('Unsupported Browser');
        return;
    }

    var SEPARATOR = (navigator.appVersion.indexOf('Win') !== -1) ? '\r\n' : '\n';
    var calendarEvents = [];
    var calendarStart = [
        'BEGIN:VCALENDAR',
        'VERSION:2.0'
    ].join(SEPARATOR);
    var calendarEnd = SEPARATOR + 'END:VCALENDAR';

    return {
        /**
         * Returns events array
         * @return {array} Events
         */
        'events': function() {
            return calendarEvents;
        },

        /**
         * Returns calendar
         * @return {string} Calendar in iCalendar format
         */
        'calendar': function() {
            return calendarStart + SEPARATOR + calendarEvents.join(SEPARATOR) + calendarEnd;
        },

        /**
         * Add event to the calendar
         * @param  {string} subject     Subject/Title of event
         * @param  {string} description Description of event
         * @param  {string} location    Location of event
         * @param  {string} begin       Beginning date of event
         * @param  {string} stop        Ending date of event
         */
        'addEvent': function(subject, description, location, begin, stop) {
            // I'm not in the mood to make these optional... So they are all required
            if (typeof subject === 'undefined' ||
                typeof description === 'undefined' ||
                typeof location === 'undefined' ||
                typeof begin === 'undefined' ||
                typeof stop === 'undefined'
            ) {
                return false;
            }

            //TODO add time and time zone? use moment to format?
            var start_date = new Date(begin);
            var end_date = new Date(stop);

            var start_year = ("0000" + (start_date.getFullYear().toString())).slice(-4);
            var start_month = ("00" + ((start_date.getMonth() + 1).toString())).slice(-2);
            var start_day = ("00" + ((start_date.getDate()).toString())).slice(-2);
            var start_hours = ("00" + (start_date.getHours().toString())).slice(-2);
            var start_minutes = ("00" + (start_date.getMinutes().toString())).slice(-2);
            var start_seconds = ("00" + (start_date.getMinutes().toString())).slice(-2);

            var end_year = ("0000" + (end_date.getFullYear().toString())).slice(-4);
            var end_month = ("00" + ((end_date.getMonth() + 1).toString())).slice(-2);
            var end_day = ("00" + ((end_date.getDate()).toString())).slice(-2);
            var end_hours = ("00" + (end_date.getHours().toString())).slice(-2);
            var end_minutes = ("00" + (end_date.getMinutes().toString())).slice(-2);
            var end_seconds = ("00" + (end_date.getMinutes().toString())).slice(-2);

            // Since some calendars don't add 0 second events, we need to remove time if there is none...
            var start_time = '';
            var end_time = '';
            if (start_minutes + start_seconds + end_minutes + end_seconds !== 0) {
                start_time = 'T' + start_hours + start_minutes + start_seconds;
                end_time = 'T' + end_hours + end_minutes + end_seconds;
            }

            var start = start_year + start_month + start_day + start_time;
            var end = end_year + end_month + end_day + end_time;

            var calendarEvent = [
                'BEGIN:VEVENT',
                'CLASS:PUBLIC',
                'DESCRIPTION:' + description,
                'DTSTART;VALUE=DATE:' + start,
                'DTEND;VALUE=DATE:' + end,
                'LOCATION:' + location,
                'SUMMARY;LANGUAGE=en-us:' + subject,
                'TRANSP:TRANSPARENT',
                'END:VEVENT'
            ].join(SEPARATOR);

            calendarEvents.push(calendarEvent);
            return calendarEvent;
        },

        /**
         * Download calendar using the saveAs function from filesave.js
         * @param  {string} filename Filename
         * @param  {string} ext      Extention
         */
        'download': function(filename, ext) {
            if (calendarEvents.length < 1) {
                return false;
            }

            ext = (typeof ext !== 'undefined') ? ext : '.ics';
            filename = (typeof filename !== 'undefined') ? filename : 'calendar';
            var calendar = calendarStart + SEPARATOR + calendarEvents.join(SEPARATOR) + calendarEnd;
            window.open( "data:text/calendar;charset=utf8," + escape(calendar));
        }
    };
};

if (typeof define === "function" && define.amd) {
  /* AMD Format */
  define("icsFormatter", [], function() {
    return icsFormatter();
  });
} else if (typeof module === "object" && module.exports) {
  /* CommonJS Format */
  module.exports = icsFormatter();
} else {
  /* Plain Browser Support */
  this.myModule = icsFormatter();
}

/**
 * Currency Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help with currency formatting
 *
 * Current contents
 * - formatMoney - Takes an amount in cents and returns it as a formatted dollar value.
 *
 */

const moneyFormat = '${{amount}}';

/**
 * Format money values based on your shop currency settings
 * @param  {Number|string} cents - value in cents or dollar amount e.g. 300 cents
 * or 3.00 dollars
 * @param  {String} format - shop money_format setting
 * @return {String} value - formatted value
 */
function formatMoney(cents, format) {
  if (typeof cents === 'string') {
    cents = cents.replace('.', '');
  }
  let value = '';
  const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  const formatString = format || moneyFormat;

  function formatWithDelimiters(number, precision, thousands, decimal) {
  	precision = precision || 2;
  	thousands = thousands || ',';
  	decimal = decimal || '.';
    if (isNaN(number) || number == null) {
      return 0;
    }

    number = (number / 100.0).toFixed(precision);

    const parts = number.split('.');
    const dollarsAmount = parts[0].replace(
      /(\d)(?=(\d\d\d)+(?!\d))/g,
      "$1"+thousands
    );
    const centsAmount = parts[1] ? decimal + parts[1] : '';

    return dollarsAmount + centsAmount;
  }

  switch (formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
  }

  return formatString.replace(placeholderRegex, value);
}

/*!
 * clipboard.js v2.0.0
 * https://zenorocha.github.io/clipboard.js
 * 
 * Licensed MIT Â© Zeno Rocha
 */
!function(t,e){"object"==typeof exports&&"object"==typeof module?module.exports=e():"function"==typeof define&&define.amd?define([],e):"object"==typeof exports?exports.ClipboardJS=e():t.ClipboardJS=e()}(this,function(){return function(t){function e(o){if(n[o])return n[o].exports;var r=n[o]={i:o,l:!1,exports:{}};return t[o].call(r.exports,r,r.exports,e),r.l=!0,r.exports}var n={};return e.m=t,e.c=n,e.i=function(t){return t},e.d=function(t,n,o){e.o(t,n)||Object.defineProperty(t,n,{configurable:!1,enumerable:!0,get:o})},e.n=function(t){var n=t&&t.__esModule?function(){return t.default}:function(){return t};return e.d(n,"a",n),n},e.o=function(t,e){return Object.prototype.hasOwnProperty.call(t,e)},e.p="",e(e.s=3)}([function(t,e,n){var o,r,i;!function(a,c){r=[t,n(7)],o=c,void 0!==(i="function"==typeof o?o.apply(e,r):o)&&(t.exports=i)}(0,function(t,e){"use strict";function n(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}var o=function(t){return t&&t.__esModule?t:{default:t}}(e),r="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t},i=function(){function t(t,e){for(var n=0;n<e.length;n++){var o=e[n];o.enumerable=o.enumerable||!1,o.configurable=!0,"value"in o&&(o.writable=!0),Object.defineProperty(t,o.key,o)}}return function(e,n,o){return n&&t(e.prototype,n),o&&t(e,o),e}}(),a=function(){function t(e){n(this,t),this.resolveOptions(e),this.initSelection()}return i(t,[{key:"resolveOptions",value:function(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{};this.action=t.action,this.container=t.container,this.emitter=t.emitter,this.target=t.target,this.text=t.text,this.trigger=t.trigger,this.selectedText=""}},{key:"initSelection",value:function(){this.text?this.selectFake():this.target&&this.selectTarget()}},{key:"selectFake",value:function(){var t=this,e="rtl"==document.documentElement.getAttribute("dir");this.removeFake(),this.fakeHandlerCallback=function(){return t.removeFake()},this.fakeHandler=this.container.addEventListener("click",this.fakeHandlerCallback)||!0,this.fakeElem=document.createElement("textarea"),this.fakeElem.style.fontSize="12pt",this.fakeElem.style.border="0",this.fakeElem.style.padding="0",this.fakeElem.style.margin="0",this.fakeElem.style.position="absolute",this.fakeElem.style[e?"right":"left"]="-9999px";var n=window.pageYOffset||document.documentElement.scrollTop;this.fakeElem.style.top=n+"px",this.fakeElem.setAttribute("readonly",""),this.fakeElem.value=this.text,this.container.appendChild(this.fakeElem),this.selectedText=(0,o.default)(this.fakeElem),this.copyText()}},{key:"removeFake",value:function(){this.fakeHandler&&(this.container.removeEventListener("click",this.fakeHandlerCallback),this.fakeHandler=null,this.fakeHandlerCallback=null),this.fakeElem&&(this.container.removeChild(this.fakeElem),this.fakeElem=null)}},{key:"selectTarget",value:function(){this.selectedText=(0,o.default)(this.target),this.copyText()}},{key:"copyText",value:function(){var t=void 0;try{t=document.execCommand(this.action)}catch(e){t=!1}this.handleResult(t)}},{key:"handleResult",value:function(t){this.emitter.emit(t?"success":"error",{action:this.action,text:this.selectedText,trigger:this.trigger,clearSelection:this.clearSelection.bind(this)})}},{key:"clearSelection",value:function(){this.trigger&&this.trigger.focus(),window.getSelection().removeAllRanges()}},{key:"destroy",value:function(){this.removeFake()}},{key:"action",set:function(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:"copy";if(this._action=t,"copy"!==this._action&&"cut"!==this._action)throw new Error('Invalid "action" value, use either "copy" or "cut"')},get:function(){return this._action}},{key:"target",set:function(t){if(void 0!==t){if(!t||"object"!==(void 0===t?"undefined":r(t))||1!==t.nodeType)throw new Error('Invalid "target" value, use a valid Element');if("copy"===this.action&&t.hasAttribute("disabled"))throw new Error('Invalid "target" attribute. Please use "readonly" instead of "disabled" attribute');if("cut"===this.action&&(t.hasAttribute("readonly")||t.hasAttribute("disabled")))throw new Error('Invalid "target" attribute. You can\'t cut text from elements with "readonly" or "disabled" attributes');this._target=t}},get:function(){return this._target}}]),t}();t.exports=a})},function(t,e,n){function o(t,e,n){if(!t&&!e&&!n)throw new Error("Missing required arguments");if(!c.string(e))throw new TypeError("Second argument must be a String");if(!c.fn(n))throw new TypeError("Third argument must be a Function");if(c.node(t))return r(t,e,n);if(c.nodeList(t))return i(t,e,n);if(c.string(t))return a(t,e,n);throw new TypeError("First argument must be a String, HTMLElement, HTMLCollection, or NodeList")}function r(t,e,n){return t.addEventListener(e,n),{destroy:function(){t.removeEventListener(e,n)}}}function i(t,e,n){return Array.prototype.forEach.call(t,function(t){t.addEventListener(e,n)}),{destroy:function(){Array.prototype.forEach.call(t,function(t){t.removeEventListener(e,n)})}}}function a(t,e,n){return u(document.body,t,e,n)}var c=n(6),u=n(5);t.exports=o},function(t,e){function n(){}n.prototype={on:function(t,e,n){var o=this.e||(this.e={});return(o[t]||(o[t]=[])).push({fn:e,ctx:n}),this},once:function(t,e,n){function o(){r.off(t,o),e.apply(n,arguments)}var r=this;return o._=e,this.on(t,o,n)},emit:function(t){var e=[].slice.call(arguments,1),n=((this.e||(this.e={}))[t]||[]).slice(),o=0,r=n.length;for(o;o<r;o++)n[o].fn.apply(n[o].ctx,e);return this},off:function(t,e){var n=this.e||(this.e={}),o=n[t],r=[];if(o&&e)for(var i=0,a=o.length;i<a;i++)o[i].fn!==e&&o[i].fn._!==e&&r.push(o[i]);return r.length?n[t]=r:delete n[t],this}},t.exports=n},function(t,e,n){var o,r,i;!function(a,c){r=[t,n(0),n(2),n(1)],o=c,void 0!==(i="function"==typeof o?o.apply(e,r):o)&&(t.exports=i)}(0,function(t,e,n,o){"use strict";function r(t){return t&&t.__esModule?t:{default:t}}function i(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}function a(t,e){if(!t)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!e||"object"!=typeof e&&"function"!=typeof e?t:e}function c(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function, not "+typeof e);t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,enumerable:!1,writable:!0,configurable:!0}}),e&&(Object.setPrototypeOf?Object.setPrototypeOf(t,e):t.__proto__=e)}function u(t,e){var n="data-clipboard-"+t;if(e.hasAttribute(n))return e.getAttribute(n)}var l=r(e),s=r(n),f=r(o),d="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t},h=function(){function t(t,e){for(var n=0;n<e.length;n++){var o=e[n];o.enumerable=o.enumerable||!1,o.configurable=!0,"value"in o&&(o.writable=!0),Object.defineProperty(t,o.key,o)}}return function(e,n,o){return n&&t(e.prototype,n),o&&t(e,o),e}}(),p=function(t){function e(t,n){i(this,e);var o=a(this,(e.__proto__||Object.getPrototypeOf(e)).call(this));return o.resolveOptions(n),o.listenClick(t),o}return c(e,t),h(e,[{key:"resolveOptions",value:function(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{};this.action="function"==typeof t.action?t.action:this.defaultAction,this.target="function"==typeof t.target?t.target:this.defaultTarget,this.text="function"==typeof t.text?t.text:this.defaultText,this.container="object"===d(t.container)?t.container:document.body}},{key:"listenClick",value:function(t){var e=this;this.listener=(0,f.default)(t,"click",function(t){return e.onClick(t)})}},{key:"onClick",value:function(t){var e=t.delegateTarget||t.currentTarget;this.clipboardAction&&(this.clipboardAction=null),this.clipboardAction=new l.default({action:this.action(e),target:this.target(e),text:this.text(e),container:this.container,trigger:e,emitter:this})}},{key:"defaultAction",value:function(t){return u("action",t)}},{key:"defaultTarget",value:function(t){var e=u("target",t);if(e)return document.querySelector(e)}},{key:"defaultText",value:function(t){return u("text",t)}},{key:"destroy",value:function(){this.listener.destroy(),this.clipboardAction&&(this.clipboardAction.destroy(),this.clipboardAction=null)}}],[{key:"isSupported",value:function(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:["copy","cut"],e="string"==typeof t?[t]:t,n=!!document.queryCommandSupported;return e.forEach(function(t){n=n&&!!document.queryCommandSupported(t)}),n}}]),e}(s.default);t.exports=p})},function(t,e){function n(t,e){for(;t&&t.nodeType!==o;){if("function"==typeof t.matches&&t.matches(e))return t;t=t.parentNode}}var o=9;if("undefined"!=typeof Element&&!Element.prototype.matches){var r=Element.prototype;r.matches=r.matchesSelector||r.mozMatchesSelector||r.msMatchesSelector||r.oMatchesSelector||r.webkitMatchesSelector}t.exports=n},function(t,e,n){function o(t,e,n,o,r){var a=i.apply(this,arguments);return t.addEventListener(n,a,r),{destroy:function(){t.removeEventListener(n,a,r)}}}function r(t,e,n,r,i){return"function"==typeof t.addEventListener?o.apply(null,arguments):"function"==typeof n?o.bind(null,document).apply(null,arguments):("string"==typeof t&&(t=document.querySelectorAll(t)),Array.prototype.map.call(t,function(t){return o(t,e,n,r,i)}))}function i(t,e,n,o){return function(n){n.delegateTarget=a(n.target,e),n.delegateTarget&&o.call(t,n)}}var a=n(4);t.exports=r},function(t,e){e.node=function(t){return void 0!==t&&t instanceof HTMLElement&&1===t.nodeType},e.nodeList=function(t){var n=Object.prototype.toString.call(t);return void 0!==t&&("[object NodeList]"===n||"[object HTMLCollection]"===n)&&"length"in t&&(0===t.length||e.node(t[0]))},e.string=function(t){return"string"==typeof t||t instanceof String},e.fn=function(t){return"[object Function]"===Object.prototype.toString.call(t)}},function(t,e){function n(t){var e;if("SELECT"===t.nodeName)t.focus(),e=t.value;else if("INPUT"===t.nodeName||"TEXTAREA"===t.nodeName){var n=t.hasAttribute("readonly");n||t.setAttribute("readonly",""),t.select(),t.setSelectionRange(0,t.value.length),n||t.removeAttribute("readonly"),e=t.value}else{t.hasAttribute("contenteditable")&&t.focus();var o=window.getSelection(),r=document.createRange();r.selectNodeContents(t),o.removeAllRanges(),o.addRange(r),e=o.toString()}return e}t.exports=n}])});